import { useContext} from "react";
import { useState } from "react";
import { useEffect } from "react";
import { services } from "../services/api";
import LoaderComponent from "../components/admin/LoaderComponent";
import { NotificacionContext } from "../context/notificacion_context";
import Grid from "@mui/material/Grid";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";
import { Autocomplete, TextField, MenuItem, IconButton } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
// import TextareaAutosize from "@mui/material/TextareaAutosize";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import dayjs from "dayjs";
import { onlyNumber, stringToBoolean } from "../utils/inputsRules";
// import CloudUploadIcon from "@mui/icons-material/CloudUpload";
import Swal from "sweetalert2";
import { useNavigate, useParams } from "react-router-dom";

const CrearFudView = () => {
  const navigate = useNavigate();
  const { id } = useParams(); // Obtener el ID de la URL para edición
  // const [selectedFile, setSelectedFile] = useState("");
  const [isEditing, setIsEditing] = useState(false);
  const [fudId, setFudId] = useState(null);
  const [state, setState] = useState({
    municipios: [],
    localidades: [],
    titulos:[],
    delitos:[],
    crimenesVinculados: [],
    step: 0,
  });

  const opcionesDelitos = (() => {
    const crimesById = new Map(
      (state.delitos || []).map((crime) => [String(crime.id), crime]),
    );
    (state.crimenesVinculados || []).forEach((crime) => {
      crimesById.set(String(crime.id), {
        ...crimesById.get(String(crime.id)),
        ...crime,
      });
    });
    return Array.from(crimesById.values());
  })();

  const [errors, setErrors] = useState({
    victim: {},
    representative: {},
    indirect_victim: {},
    facts: {},
    preliminary_observations: {},
    authorities: {},
    complementary_form: {},
  });

  const [loader, setLoader] = useState({
    loading: false,
  });
  const { showNotification } = useContext(NotificacionContext);

  const uppercaseText = (value) =>
    typeof value === "string" ? value.toUpperCase() : value;

  const clearSelectButton = (value, label, onClear) =>
    value ? (
      <IconButton
        aria-label={`Limpiar ${label}`}
        title={`Limpiar ${label}`}
        size="small"
        onMouseDown={(event) => {
          event.preventDefault();
          event.stopPropagation();
        }}
        onClick={(event) => {
          event.stopPropagation();
          onClear();
        }}
        sx={{
          position: "absolute",
          top: "50%",
          right: 32,
          transform: "translateY(-50%)",
          zIndex: 1,
        }}
      >
        <CloseIcon fontSize="small" />
      </IconButton>
    ) : null;

  const normalizeMultiSelect = (value) => {
    if (Array.isArray(value)) return value;
    if (typeof value === "string" && value) {
      return value.split(",").map((item) => item.trim()).filter(Boolean);
    }
    return [];
  };

  const normalizeCrimeIds = (value) => {
    const crimes = Array.isArray(value) ? value : value == null || value === "" ? [] : [value];
    return crimes
      .map((crime) => (crime && typeof crime === "object" ? crime.id : crime))
      .filter((crimeId) => crimeId != null && crimeId !== "");
  };

  const obtenerTitulos = async () => {
    try {
      const response = await services({
        method: "GET",
        service: `degrees`,
        body: null,
      });

      if (response.status === 200) {
        setState((prev) => ({
          ...prev,
          titulos: response.data,
        }));
      }
    } catch (error) {
      showNotification("error", "Error", "No se pudieron cargar los títulos", null, 4);
    }
  };

  const obtenerDelitos = async () => {
    try {
      const response = await services({
        method: "GET",
        service: `crimes`,
        body: null,
      });

      if (response.status === 200) {
        setState((prev) => ({
          ...prev,
          delitos: response.data,
        }));
      }
    } catch (error) {
      showNotification("error", "Error", "No se pudieron cargar los delitos", null, 4);
    }
  };

  const obtenerMunicipios = async () => {
    try {
      const response = await services({
        method: "GET",
        service: `municipalities`,
        body: null,
      });

      if (response.status === 200) {
        setState((prev) => ({
          ...prev,
          municipios: response.data,
        }));
      }
    } catch (error) {
      showNotification("error", "Error", "No se pudieron cargar los municipios", null, 4);
    }
  };

  const obtenerFudPorId = async (id) => {
    try {
      setLoader((prev) => ({ ...prev, loading: true }));
      const response = await services({
        method: "GET",
        service: `fud/${id}`,
        body: null,
      });

      if (response.status === 200) {
        const fudData = response.data?.data || response.data;
        const authority = fudData.authority || {};
        const mpCrimes = authority.mpCrimes ?? authority.mp_crimes;
        const judicialCrimes = authority.judicialCrimes ?? authority.judicial_crimes;
        const mpCrimeIds = normalizeCrimeIds(mpCrimes ?? authority.mp_crime_id);
        const judicialCrimeIds = normalizeCrimeIds(
          judicialCrimes ?? authority.judicial_crime_id,
        );
        const associatedCrimes = [
          ...(Array.isArray(mpCrimes) ? mpCrimes : mpCrimes ? [mpCrimes] : []),
          ...(Array.isArray(judicialCrimes)
            ? judicialCrimes
            : judicialCrimes
              ? [judicialCrimes]
              : []),
        ].filter((crime) => crime && typeof crime === "object" && crime.id != null);

        setState((prev) => ({
          ...prev,
          crimenesVinculados: associatedCrimes,
        }));

        // Poblar el formulario con los datos del FUD
        setFormulario({
          victim: {
            requested_by: fudData.requested_by || "",
            victim_type: fudData.victim_type || "",
            name: fudData.name || "",
            first_lastname: fudData.first_lastname || "",
            second_lastname: fudData.second_lastname || "",
            degree_id: fudData.degree_id || "",
            birthdate: fudData.birthdate ? dayjs(fudData.birthdate).format("YYYY-MM-DD") : "",
            age: fudData.age || "",
            sex: fudData.sex || "",
            nationality: fudData.nationality || "",
            place_birth_country: fudData.place_birth_country || "",
            place_birth_entity: fudData.place_birth_entity || "",
            place_birth_municipality: fudData.place_birth_municipality || "",
            place_birth_town: fudData.place_birth_town || "",
            marital_status: fudData.marital_status || "",
            curp: fudData.curp || "",
            cp: fudData.cp || "",
            colony: fudData.colony || "",
            locality_id: fudData.locality_id || "",
            municipality_id: fudData.municipality_id || "",
            street: fudData.street || "",
            number: fudData.number || "",
            federal_entity: fudData.federal_entity || "",
            phone: fudData.phone || "",
            email: fudData.email || "",
            date: fudData.date ? dayjs(fudData.date).format("YYYY-MM-DD") : "",
            place_local: fudData.place_local || "",
            has_identification: !!fudData.has_identification,
            identification_number: fudData.identification_number || "",
            identification_type: fudData.identification_type || "",
          },
          representative: fudData.representative || {
            name: "",
            first_lastname: "",
            second_lastname: "",
            relationship: "",
            phone: "",
            email: "",
            other_information: "",
          },
          indirect_victims: fudData.indirect_victim && fudData.indirect_victim.length > 0 
            ? fudData.indirect_victim 
            : [{ full_name: "", relationship: "" }],
          facts: {
            street: fudData.fact?.street || "",
            external_number: fudData.fact?.external_number || "",
            internal_number: fudData.fact?.internal_number || "",
            cp: fudData.fact?.cp || "",
            colony: fudData.fact?.colony || "",
            locality: fudData.fact?.locality || "",
            municipality: fudData.fact?.municipality || "",
            federal_entity: fudData.fact?.federal_entity || "",
            facts_date: fudData.fact?.facts_date ? dayjs(fudData.fact.facts_date).format("YYYY-MM-DD") : "",
            facts: fudData.fact?.facts || "",
          },
          preliminary_observations: {
            damage_type: fudData.observation?.damage_type || [],
            damage_other: fudData.observation?.damage_other || "",
            gender_violence: !!fudData.observation?.gender_violence,
            violence_type: fudData.observation?.violence_type || [],
            violence_other: fudData.observation?.violence_other || "",
            authority_notes: fudData.observation?.authority_notes || "",
          },
          authorities: {
            reported_to_mp: !!fudData.authority?.reported_to_mp,
            mp_date: fudData.authority?.mp_date ? dayjs(fudData.authority.mp_date).format("YYYY-MM-DD") : "",
            mp_jurisdiction: fudData.authority?.mp_jurisdiction || "",
            mp_state: fudData.authority?.mp_state || "",
            mp_crime_id: mpCrimeIds,
            mp_agency: fudData.authority?.mp_agency || "",
            mp_file_type: fudData.authority?.mp_file_type || "",
            mp_nuc: fudData.authority?.mp_nuc || "",
            mp_exp: fudData.authority?.mp_exp || "",
            mp_status: fudData.authority?.mp_status || "",

            judicial_start_date: fudData.authority?.judicial_start_date ? dayjs(fudData.authority.judicial_start_date).format("YYYY-MM-DD") : "",
            judicial_jurisdiction: fudData.authority?.judicial_jurisdiction || "",
            judicial_state: fudData.authority?.judicial_state || "",
            judicial_crime_id: judicialCrimeIds,
            court_number: fudData.authority?.court_number || "",
            process_number: fudData.authority?.process_number || "",
            CA: fudData.authority?.CA || "",
            judicial_status: fudData.authority?.judicial_status || "",

            complaint_ddhh: !!fudData.authority?.complaint_ddhh,
            ddhh_date: fudData.authority?.ddhh_date ? dayjs(fudData.authority.ddhh_date).format("YYYY-MM-DD") : "",
            ddhh_competence: fudData.authority?.ddhh_competence || "",
            organism: fudData.authority?.organism || "",
            violation: fudData.authority?.violation || "",
            responsible_authority: fudData.authority?.responsible_authority || "",
            folio: fudData.authority?.folio || "",
            current_status: fudData.authority?.current_status || "",
            other_authority: fudData.authority?.other_authority || "",

          },
          complementary_form: {
            ceeav_code: fudData.complementary_form?.ceeav_code || "",
            case_file: fudData.complementary_form?.case_file || "",
            referring_institution: fudData.complementary_form?.referring_institution || "",
            requested_services: fudData.complementary_form?.requested_services || [],
            registry_status: fudData.complementary_form?.registry_status || "",
            is_vulnerable_group: !!fudData.complementary_form?.is_vulnerable_group,
            vulnerable_group: fudData.complementary_form?.vulnerable_group || [],
            notes: fudData.complementary_form?.notes || "",
            leaves_orphans: !!fudData.complementary_form?.leaves_orphans,
            orphans_count: fudData.complementary_form?.orphans_count || "",
            violence_types: fudData.complementary_form?.violence_types || "",
            other_violence: fudData.complementary_form?.other_violence || "",
            violence_feminist: normalizeMultiSelect(
              fudData.complementary_form?.violence_feminist,
            ),
            other_violence_feminist: fudData.complementary_form?.other_violence_feminist || "",
            offender_name: fudData.complementary_form?.offender_name || "",
            relationship: fudData.complementary_form?.relationship || "",
          },
        });
        setIsEditing(true);
        setFudId(id);
      }
    } catch (error) {
      showNotification("error", "Error", "No se pudo cargar el FUD", null, 4);
    } finally {
      setLoader((prev) => ({ ...prev, loading: false }));
    }
  };

  const [formularioState, setFormulario] = useState({
    victim: {
      requested_by: "",
      victim_type: "",
      name: "",
      first_lastname: "",
      second_lastname: "",
      degree_id: "",
      birthdate: "",
      age: "",
      sex: "",
      nationality: "",
      place_birth_country: "",
      place_birth_entity: "",
      place_birth_municipality: "",
      place_birth_town: "",
      marital_status: "",
      curp: "",
      cp: "",
      colony: "",
      locality_id: "",
      municipality_id: "",
      street: "",
      number: "",
      federal_entity: "",
      phone: "",
      email: "",
      date: "",
      place_local: "",
      has_identification: "",
      identification_number: "",
      identification_type: "",
    },

    representative: {
      name: "",
      first_lastname: "",
      second_lastname: "",
      relationship: "",
      phone: "",
      email: "",
      other_information: "",
    },

    indirect_victims: [
      {
        full_name: "",
        relationship: "",
      }
    ],

    facts: {
      street: "",
      external_number: "",
      internal_number: "",
      cp: "",
      colony: "",
      locality: "",
      municipality: "",
      federal_entity: "",
      facts_date: "",
      facts: "",
    },

    preliminary_observations: {
      damage_type: [],
      damage_other: "",
      gender_violence: "",
      violence_type: [],
      violence_other: "",
      authority_notes: "",
    },

    authorities: {
      reported_to_mp: "",
      mp_date: "",
      mp_jurisdiction: "",
      mp_state: "",
      mp_crime_id: [],
      mp_agency: "",
      mp_file_type: "",
      mp_nuc: "",
      mp_exp: "",
      mp_status: "",
      judicial_start_date: "",
      judicial_jurisdiction: "",
      judicial_state: "",
      judicial_crime_id: [],
      court_number: "",
      process_number: "",
      CA: "",
      judicial_status: "",
      complaint_ddhh: "",
      ddhh_date: "",
      ddhh_competence: "",
      organism: "",
      violation: "",
      responsible_authority: "",
      folio: "",
      current_status: "",
      other_authority:"",
    },

    complementary_form: {
      ceeav_code: "",
      case_file: "",
      referring_institution: "",
      requested_services: [],
      registry_status: "",
      is_vulnerable_group: "",
      vulnerable_group: [],
      notes: "",
      leaves_orphans: "",
      orphans_count: "",
      violence_types: "",
      other_violence: "",
      violence_feminist: [],
      other_violence_feminist: "",
      offender_name: "",
      relationship: "",
    },
  });

  const handleChange = (section, field, value) => {
    setFormulario((prev) => {
      if (section === "victim" && field === "has_identification" && value === false) {
        return {
          ...prev,
          victim: {
            ...prev.victim,
            has_identification: value,
            identification_number: "",
            identification_type: "",
          },
        };
      }
      if (section === "preliminary_observations" && field === "damage_type") {
        const selectedDamageTypes = normalizeMultiSelect(value);
        return {
          ...prev,
          preliminary_observations: {
            ...prev.preliminary_observations,
            damage_type: selectedDamageTypes,
            damage_other: selectedDamageTypes.includes("OTRO")
              ? prev.preliminary_observations.damage_other
              : "",
          },
        };
      }
      if (section === "preliminary_observations" && field === "gender_violence" && value === false) {
        return {
          ...prev,
          preliminary_observations: {
            ...prev.preliminary_observations,
            gender_violence: value,
            violence_type: [],
            violence_other: "",
          },
        };
      }
      if (section === "preliminary_observations" && field === "violence_type") {
        const selectedViolenceTypes = normalizeMultiSelect(value);
        return {
          ...prev,
          preliminary_observations: {
            ...prev.preliminary_observations,
            violence_type: selectedViolenceTypes,
            violence_other: selectedViolenceTypes.includes("OTRA")
              ? prev.preliminary_observations.violence_other
              : "",
          },
        };
      }

      if (section === "authorities" && field === "reported_to_mp" && value === false) {
        return {
          ...prev,
          authorities: {
            ...prev.authorities,
            reported_to_mp: value,
            mp_date : "",
            mp_jurisdiction : "",
            mp_state : "",
            mp_crime_id : [],
            mp_agency : "",
            mp_file_type : "",
            mp_nuc : "",
            mp_exp : "",
            mp_status : "",
          },
        };
      }
      if (section === "authorities" && field === "complaint_ddhh" && value === false) {
        return {
          ...prev,
          authorities: {
            ...prev.authorities,
            complaint_ddhh: value,
            ddhh_date: "",
            ddhh_competence : "",
            organism : "",
            violation : "",
            responsible_authority : "",
            folio : "",
            current_status : "",
            other_authority : "",             
          },
        };
      }
      if (section === "complementary_form" && field === "is_vulnerable_group" && value === false) {
        return {
          ...prev,
          complementary_form: {
            ...prev.complementary_form,
            is_vulnerable_group: value,
            vulnerable_group: [],
            notes: "",
          },
        };
      }
      if (section === "complementary_form" && field === "leaves_orphans" && value === false) {
        return {
          ...prev,
          complementary_form: {
            ...prev.complementary_form,
            leaves_orphans: value,
            orphans_count: "",
          },
        };
      }
      if (section === "complementary_form" && field === "violence_types" && value !== "OTRO") {
        return {
          ...prev,
          complementary_form: {
            ...prev.complementary_form,
            violence_types: value,
            other_violence: "",
          },
        };
      }
      if (section === "complementary_form" && field === "violence_feminist") {
        const selectedViolenceTypes = normalizeMultiSelect(value);
        return {
          ...prev,
          complementary_form: {
            ...prev.complementary_form,
            violence_feminist: selectedViolenceTypes,
            other_violence_feminist: selectedViolenceTypes.includes("OTRA")
              ? prev.complementary_form.other_violence_feminist
              : "",
          },
        };
      }
      return {
        ...prev,
        [section]: {
          ...prev[section],
          [field]: value,
        },
      };
    });
  };

  // Funciones para manejar múltiples víctimas indirectas
  const handleIndirectVictimChange = (index, field, value) => {
    setFormulario((prev) => ({
      ...prev,
      indirect_victims: prev.indirect_victims.map((victim, i) =>
        i === index ? { ...victim, [field]: value } : victim
      ),
    }));
  };

  const handleAddIndirectVictim = () => {
    setFormulario((prev) => ({
      ...prev,
      indirect_victims: [
        ...prev.indirect_victims,
        { full_name: "", relationship: "" },
      ],
    }));
  };

  const handleRemoveIndirectVictim = (index) => {
    setFormulario((prev) => ({
      ...prev,
      indirect_victims: prev.indirect_victims.filter((_, i) => i !== index),
    }));
  };

  const handleMunicipality_id = async (newValue) => {
    if (!newValue) {
      handleChange("victim", "municipality_id", "");
      handleChange("victim", "locality_id", "");

      setState((prev) => ({
        ...prev,
        localidades: [],
      }));
      return;
    }

    handleChange("victim", "municipality_id", newValue.id);
    if (!isEditing) {
      handleChange("victim", "locality_id", "");
    }

    try {
      const response = await services({
        method: "GET",
        service: `localities?municipality_id=${newValue.id}`,
        body: null,
      });

      if (response.status === 200) {
        setState((prev) => ({
          ...prev,
          localidades: response.data,
        }));
      }
    } catch (error) {
      showNotification("error", "Error", "No se pudieron cargar las localidades", null, 4);
    }
  };

  const regexCurp =
    /^([A-Z][AEIOUX][A-Z]{2}\d{2}(?:0[1-9]|1[0-2])(?:0[1-9]|[12]\d|3[01])[HM](?:AS|B[CS]|C[CLMSH]|D[FG]|G[TR]|HG|JC|M[CNS]|N[ETL]|OC|PL|Q[TR]|S[PLR]|T[CSL]|VZ|YN|ZS)[B-DF-HJ-NP-TV-Z]{3}[A-Z\d])(\d)$/;

  const regexEmail = /^[^\s@]{1,64}@[^\s@]{1,255}\.[^\s@]{2,24}$/;

  // const regexIne = /^[A-Z]{6}\d{8}[H M]\d{3}$/;
  
  const validarStep0 = () => {
    let errorsRep = {};
    let errorsVictim = {};

    if (!formularioState.victim.place_local) {
      errorsVictim.place_local = "Este campo es requerido";
    }
    if (!formularioState.victim.requested_by) {
      errorsVictim.requested_by = "Este campo es requerido";
    }
    if (formularioState.victim.requested_by !== "A") {
      if (!formularioState.representative.name) {
        errorsRep.name = "Este campo es requerido";
      }
      if (!formularioState.representative.first_lastname) {
        errorsRep.first_lastname = "Este campo es requerido";
      }
      if (!formularioState.representative.first_lastname) {
        errorsRep.first_lastname = "Este campo es requerido";
      }
      if (!formularioState.representative.phone) {
        errorsRep.phone = "Este campo es requerido";
      } else if (formularioState.representative.phone.length < 10) {
        errorsRep.phone = "Número inválido";
      }
      if (formularioState.representative.landline_phone) {
        if (formularioState.representative.phone.length < 10) {
          errorsRep.phone = "Número inválido";
        }
      }
      if (formularioState.representative.email) {
        if(!regexEmail.test(formularioState.representative.email)) {
          errorsRep.email = "Email inválido";
        }
      }
    }

    if(!formularioState.victim.victim_type) {
      errorsVictim.victim_type = "Este campo es requerido";
    }
    if (!formularioState.victim.name) {
      errorsVictim.name = "Este campo es requerido";
    }
    if (!formularioState.victim.first_lastname) {
      errorsVictim.first_lastname = "Este campo es requerido";
    }
    if (!formularioState.victim.age) {
      errorsVictim.age = "Este campo es requerido";
    }
    if (!formularioState.victim.sex) {
      errorsVictim.sex = "Este campo es requerido";
    }
    if (!formularioState.victim.nationality) {
      errorsVictim.nationality = "Este campo es requerido";
    }
    // if (!formularioState.victim.curp) {
    //   errorsVictim.curp = "Este campo es requerido";
    // } else if (!regexCurp.test(formularioState.victim.curp)) {
    //   errorsVictim.curp = "CURP inválida";
    // }
    if (!formularioState.victim.marital_status) {
      errorsVictim.marital_status = "Este campo es requerido";
    }
    if(!formularioState.victim.place_birth_country) { 
      errorsVictim.place_birth_country = "Este campo es requerido";
    }
    if(!formularioState.victim.place_birth_entity) { 
      errorsVictim.place_birth_entity = "Este campo es requerido";
    }
    if(!formularioState.victim.place_birth_municipality) { 
      errorsVictim.place_birth_municipality = "Este campo es requerido";
    }
    if (!formularioState.victim.federal_entity) {
      errorsVictim.federal_entity = "Este campo es requerido";
    }
    // if (!formularioState.victim.municipality_id) {
    //   errorsVictim.municipality_id = "Selecciona municipio";
    // }
    // if (!formularioState.victim.locality_id) {
    //   errorsVictim.locality_id = "Selecciona localidad";
    // }
    if(!formularioState.victim.phone) {  
      errorsVictim.phone = "Este campo es requerido";
    } else if (formularioState.victim.phone.length < 10) {
      errorsVictim.phone = "Número inválido";
    }
    if (formularioState.victim.email) {
      if(!regexEmail.test(formularioState.victim.email)) {
        errorsVictim.email = "Email inválido";
      }
    }

    return { representative: errorsRep, victim: errorsVictim };
  };

  const validarStep1 = () => {
 
    let errorsVictim = {};
    let errorsFacts = {};

    if (formularioState.victim.has_identification === "") {
      errorsVictim.has_identification = "Este campo es requerido";
    }
    if (formularioState.victim.has_identification) {
      if (!formularioState.victim.identification_type) {
        errorsVictim.identification_type = "Este campo es requerido";
      }
      if (!formularioState.victim.identification_number) {
        errorsVictim.identification_number = "Este campo es requerido";
      }
    }
    if (!formularioState.facts.locality) {
      errorsFacts.locality = "Este campo es requerido";
    }
    if (!formularioState.facts.municipality) {
      errorsFacts.municipality = "Este campo es requerido";
    }
    if (!formularioState.facts.federal_entity) {
      errorsFacts.federal_entity = "Este campo es requerido";
    }
    if (!formularioState.facts.facts) {
      errorsFacts.facts = "Este campo es requerido";
    }
    return { victim: errorsVictim, facts: errorsFacts };
  };

  const validarStep2 = () => {
 
    let errorsPreliminary = {};
    let errorsAuthority = {};

    const selectedDamageTypes = normalizeMultiSelect(
      formularioState.preliminary_observations.damage_type,
    );
    const selectedViolenceTypes = normalizeMultiSelect(
      formularioState.preliminary_observations.violence_type,
    );

    if (selectedDamageTypes.length === 0) {
      errorsPreliminary.damage_type = "Este campo es requerido";
    }
    if (selectedDamageTypes.includes("OTRO")) {
      if (!formularioState.preliminary_observations.damage_other) {
        errorsPreliminary.damage_other = "Este campo es requerido";
      }
    }
    
    if (formularioState.preliminary_observations.gender_violence === "") {
      errorsPreliminary.gender_violence = "Este campo es requerido";
    }
    if (formularioState.preliminary_observations.gender_violence) {
      if (selectedViolenceTypes.length === 0) {
        errorsPreliminary.violence_type = "Este campo es requerido";
      }
    }
    if (selectedViolenceTypes.includes("OTRA")) {
      if (!formularioState.preliminary_observations.violence_other) {
        errorsPreliminary.violence_other = "Este campo es requerido";
      }
    }

    if (formularioState.authorities.reported_to_mp === "") {
      errorsAuthority.reported_to_mp = "Este campo es requerido";
    }
    if (formularioState.authorities.reported_to_mp) {
      if (!formularioState.authorities.mp_jurisdiction) {
        errorsAuthority.mp_jurisdiction = "Este campo es requerido";
      }
      if (!formularioState.authorities.mp_state) {
        errorsAuthority.mp_state = "Este campo es requerido";
      }
      if (!normalizeCrimeIds(formularioState.authorities.mp_crime_id).length) {
        errorsAuthority.mp_crime_id = "Este campo es requerido";
      }
      if (!formularioState.authorities.mp_agency) {
        errorsAuthority.mp_agency = "Este campo es requerido";
      }
      if (formularioState.authorities.mp_nuc) {
        if (formularioState.authorities.mp_nuc.length < 13) {
          errorsAuthority.mp_nuc = "Campo inválido";
        }
      }
      if (formularioState.authorities.mp_exp) {
        if (formularioState.authorities.mp_exp.length < 19) {
          errorsAuthority.mp_exp = "Campo inválido";
        }
      }
      if (!formularioState.authorities.mp_status) {
        errorsAuthority.mp_status = "Este campo es requerido";
      }
    }
    
    if (formularioState.authorities.court_number) {
      if (formularioState.authorities.court_number.length >50 ) {
        errorsAuthority.court_number = "Campo inválido";
      }
    }
    if (formularioState.authorities.process_number) {
      if (formularioState.authorities.process_number.length !== 9 ) {
        errorsAuthority.process_number = "Campo inválido";
      }
    }
    
    if (formularioState.authorities.complaint_ddhh === "") {
      errorsAuthority.complaint_ddhh = "Este campo es requerido";
    }
    if (formularioState.authorities.complaint_ddhh) {
      if (!formularioState.authorities.ddhh_competence) {
        errorsAuthority.ddhh_competence = "Este campo es requerido";
      }
      if (!formularioState.authorities.organism) {
        errorsAuthority.organism = "Este campo es requerido";
      }
      if (!formularioState.authorities.violation) {
        errorsAuthority.violation = "Este campo es requerido";
      }
      if (!formularioState.authorities.responsible_authority) {
        errorsAuthority.responsible_authority = "Este campo es requerido";
      }
      if (!formularioState.authorities.folio) {
        errorsAuthority.folio = "Este campo es requerido";
      } else if (formularioState.authorities.folio.length > 20) {
        errorsAuthority.folio = "Campo inválido";
      }
    }
    return { preliminary_observations: errorsPreliminary, authorities: errorsAuthority };
  };

  const validarStep3 = () => {
 
    let errorsComplementary= {};

    if (formularioState.complementary_form.requested_services.length === 0) {
      errorsComplementary.requested_services = "Este campo es requerido";
    }
    if (formularioState.complementary_form.is_vulnerable_group === "") {
      errorsComplementary.is_vulnerable_group = "Este campo es requerido";
    }
    if (formularioState.complementary_form.is_vulnerable_group) {
      if (!formularioState.complementary_form.vulnerable_group) {
        errorsComplementary.vulnerable_group = "Este campo es requerido";
      }
      if (!formularioState.complementary_form.notes) {
        errorsComplementary.notes = "Este campo es requerido";
      }
    }

    if (formularioState.complementary_form.leaves_orphans === "") {
      errorsComplementary.leaves_orphans = "Este campo es requerido";
    }
    if (formularioState.complementary_form.leaves_orphans) {
      if (!formularioState.complementary_form.orphans_count) {
        errorsComplementary.orphans_count = "Este campo es requerido";
      }
    }
    // if (!formularioState.complementary_form.violence_types) {
    //   errorsComplementary.violence_types = "Este campo es requerido";
    // }
    if (formularioState.complementary_form.violence_types === "OTRO") {
      if (!formularioState.complementary_form.other_violence) {
        errorsComplementary.other_violence = "Este campo es requerido";
      }
    }

    // if (!formularioState.complementary_form.violence_feminist) {
    //   errorsComplementary.violence_feminist = "Este campo es requerido";
    // }
    if (
      normalizeMultiSelect(
        formularioState.complementary_form.violence_feminist,
      ).includes("OTRA")
    ) {
      if (!formularioState.complementary_form.other_violence_feminist) {
        errorsComplementary.other_violence_feminist = "Este campo es requerido";
      }
    }
    return { complementary_form: errorsComplementary };
};

  const validarFormulario = () => {
    let newErrors = {
      victim: {},
      representative: {},
      indirect_victim: {},
      facts: {},
      preliminary_observations: {},
      authorities: {},
      complementary_form: {},
    };

    if (state.step === 0) {
      const stepErrors = validarStep0();
      newErrors = { ...newErrors, ...stepErrors };
    }

    if (state.step === 1) {
      const stepErrors = validarStep1();
      newErrors = { ...newErrors, ...stepErrors };
    }

    if (state.step === 2) {
      const stepErrors = validarStep2();
      newErrors = { ...newErrors, ...stepErrors };
    }
    if (state.step === 3) {
      const stepErrors = validarStep3();
      newErrors = { ...newErrors, ...stepErrors };
    }
    setErrors(newErrors);

    const hasErrors = Object.values(newErrors).some(
      (section) => Object.keys(section).length > 0
    );

    return !hasErrors;
  };

  const prepararDatosParaEnvio = () => {
    const datos = {
      ...formularioState,
      preliminary_observations: {
        ...formularioState.preliminary_observations,
        damage_type: normalizeMultiSelect(
          formularioState.preliminary_observations.damage_type,
        ),
        violence_type: normalizeMultiSelect(
          formularioState.preliminary_observations.violence_type,
        ),
      },
      complementary_form: {
        ...formularioState.complementary_form,
        violence_feminist: normalizeMultiSelect(
          formularioState.complementary_form.violence_feminist,
        ),
      },
      authorities: {
        ...formularioState.authorities,
        mp_crime_id: normalizeCrimeIds(formularioState.authorities.mp_crime_id),
        judicial_crime_id: normalizeCrimeIds(
          formularioState.authorities.judicial_crime_id,
        ),
      },
    };

    // Verificar si representative tiene datos válidos
    const representativeTieneDatos = formularioState.representative.name ||
                                     formularioState.representative.first_lastname ||
                                     formularioState.representative.phone ||
                                     formularioState.representative.email;

    if (!representativeTieneDatos) {
      delete datos.representative;
    }

    // Verificar si indirect_victims tiene datos válidos
    const indirectVictimsTieneDatos = formularioState.indirect_victims.some(victim =>
      victim.full_name.trim() !== "" || victim.relationship.trim() !== ""
    );

    if (!indirectVictimsTieneDatos) {
      delete datos.indirect_victims;
    }

    return datos;
  };

  const handleSubmitFud = async () => {
    if (!validarFormulario()) return;

    setLoader((prev) => ({ ...prev, loading: true }));

    // Preparar datos para envío, excluyendo campos opcionales vacíos
    const datosParaEnvio = prepararDatosParaEnvio();
    const method = isEditing ? "PUT" : "POST";
    const service = isEditing ? `fud/${fudId}` : "fud";

    const response = await services({
      method: method,
      service: service,
      body: datosParaEnvio,
    });

    setLoader((prev) => ({ ...prev, loading: false }));

    if (response.status === (isEditing ? 200 : 201)) {
      limpiarFormulario();
      Swal.fire({
        title: isEditing ? "FUD actualizado con éxito" : "FUD creado con éxito",
        confirmButtonText: "Aceptar",
      });
      navigate("/victimas");
    } else {
      showNotification("error", "Error", "Algo salió mal", null, 4);
    }
  };

  const limpiarFormulario = () => {
    setFormulario({
      victim: {
        requested_by: "",
        victim_type: "",
        name: "",
        first_lastname: "",
        second_lastname: "",
        degree_id: "",
        birthdate: "",
        age: "",
        sex: "",
        nationality: "",
        place_birth_country: "",
        place_birth_entity: "",
        place_birth_municipality: "",
        place_birth_town: "",
        marital_status: "",
        curp: "",
        cp: "",
        colony: "",
        locality_id: "",
        municipality_id: "",
        street: "",
        number: "",
        federal_entity: "",
        phone: "",
        email: "",
        date: "",
        place_local: "",
        has_identification: "",
        identification_number: "",
        identification_type: "",
      },

      representative: {
        name: "",
        first_lastname: "",
        second_lastname: "",
        relationship: "",
        phone: "",
        email: "",
        other_information: "",
      },

      indirect_victims: [
        {
          full_name: "",
          relationship: "",
        }
      ],

      facts: {
        street: "",
        external_number: "",
        internal_number: "",
        cp: "",
        colony: "",
        locality: "",
        municipality: "",
        federal_entity: "",
        facts_date: "",
        facts: "",
      },

      preliminary_observations: {
        damage_type: [],
        gender_violence: "",
        violence_type: [],
        authority_notes: "",
      },

      authorities: {
        reported_to_mp: "",
        mp_date: "",
        mp_jurisdiction: "",
        mp_state: "",
        mp_crime_id: [],
        mp_agency: "",
        mp_file_type: "",
        mp_nuc: "",
        mp_exp: "",
        mp_status: "",

        judicial_start_date: "",
        judicial_jurisdiction: "",
        judicial_state: "",
        judicial_crime_id: [],
        court_number: "",
        process_number: "",
        CA: "",
        judicial_status: "",
        complaint_ddhh: "",
        ddhh_date: "",
        ddhh_competence: "",
        organism: "",
        violation: "",
        responsible_authority: "",
        folio: "",
        current_status: "",
        other_authority:"",
      },

      complementary_form: {
        ceeav_code: "",
        case_file: "",
        referring_institution: "",
        requested_services: [],
        registry_status: "",
        is_vulnerable_group: "",
        vulnerable_group: [],
        notes: "",
        leaves_orphans: "",
        orphans_count: "",
        violence_types: "",
        other_violence: "",
        violence_feminist: [],
        other_violence_feminist: "",
        offender_name: "",
        relationship: "",
      },
      
    });
    // setSelectedFile("");
  };
  const handleRemoveStep = () => {
    let newStep = state.step;
    if (state.step !== 0) {
      setState({ ...state, step: newStep - 1 });
    }
  };
 
  const handleAddStep = () => {
    if (!validarFormulario()) return;

    if (state.step !== 3) {
      setState((prev) => ({
        ...prev,
        step: prev.step + 1,
      }));
    }
  };
  // const handleFileChange = (event) => {
  //   const file = event.target.files[0];
  //   setSelectedFile(file);
  // };

  // const fileInputRef = useRef(null);

  useEffect(() => {
    obtenerTitulos();
    obtenerDelitos();
    obtenerMunicipios();
    
    // Si hay un ID en la URL, es edición
    if (id) {
      obtenerFudPorId(id);
    }
  }, [id]);

  // useEffect para cargar localidades cuando se está editando
  useEffect(() => {
    if (isEditing && formularioState.victim.municipality_id && state.municipios.length > 0) {
      const municipio = state.municipios.find(m => m.id === parseInt(formularioState.victim.municipality_id));
      if (municipio) {
        handleMunicipality_id(municipio);
      }
    }
  }, [isEditing, formularioState.victim.municipality_id, state.municipios]);

  return (
    <div className="container">
      {loader.loading && <LoaderComponent />}
      {/* <div className="text-big pt-3">Sistema para el Seguimiento de la Atención a Victimas</div> */}

      <div className="card card--GuindaSFA card--rounded mt-3">
        <div className=" d-flex justify-content-center ">
          <div
            className={
              state.solicitud
                ? "ms-4 cta-line"
                : " cta-line-active ms-4 cta-line"
            }
          >
            {/* CREAR FUD */}
            {isEditing ? "Actualizar FUD" : "Crear FUD"}
          </div>
        </div>
      </div>
      <div className="mt-5 card card--rounded ">
        <div className="my-3">
          Para generar un FUD, es necesario que llene los siguientes campos:
        </div>

        <Grid container spacing={3}>
          {state.step === 0 && (
            <>
              <Grid item xs={12} sm={6}>
                <TextField
                  sx={{ borderRadius: "30px" }}
                  required
                  fullWidth
                  size="small"
                  id="place_local_victim"
                  label="LUGAR DE LA SOLICITUD"
                  variant="outlined"
                  error={!!errors.victim?.place_local}
                  helperText={errors.victim?.place_local || ""}
                  value={formularioState.victim.place_local}
                  onChange={(e) =>
                    handleChange("victim", "place_local", uppercaseText(e.target.value))
                  }  
                />
              </Grid>
              <Grid item xs={12} sm={6}>
                <LocalizationProvider dateAdapter={AdapterDayjs}>
                  <DatePicker
                    required
                    label="FECHA DE LA SOLICITUD"
                    id="date_victim"
                    style={{ width: "40%", marginLeft: "10px" }}
                    value={
                      formularioState.victim.date
                        ? dayjs(formularioState.victim.date)
                        : null
                    }
                    onChange={(newValue) =>
                      handleChange(
                        "victim",
                        "date",
                        newValue ? newValue.format("YYYY-MM-DD") : ""
                      )
                    }
                    format="DD/MM/YYYY"
                    maxDate={dayjs()}
                    slotProps={{
                      textField: {
                        fullWidth: true,
                        size: "small",
                        error: !!errors.victim?.date,
                        helperText: errors.victim?.date || "",
                      },
                    }}
                  />
                </LocalizationProvider>
              </Grid>

              <Grid item xs={12}>
                <Typography
                  className="my-3"
                  align="center"
                  fontWeight="bold"
                >
                  I DATOS DEL/LA SOLICITANTE
                </Typography>
              </Grid>
              <Grid item xs={12} sm={6}>
                <TextField 
                  fullWidth 
                  size="small" 
                  label="QUIEN REALIZA LA SOLICITUD" 
                  variant="outlined" 
                  select 
                  error={!!errors.victim?.requested_by} 
                  helperText={errors.victim?.requested_by || ""}  
                  value={formularioState.victim.requested_by}
                  onChange={(e) =>
                  handleChange("victim", "requested_by", uppercaseText(e.target.value))
                  } 
                >
                  <MenuItem value="A">VÍCTIMA</MenuItem>
                  <MenuItem value="B">FAMILIAR O PERSONA DE CONFIANZA</MenuItem>
                  <MenuItem value="C">SERVIDOR PÚBLICO/A O AUTORIDAD</MenuItem>
                  <MenuItem value="D">REPRESENTANTE LEGAL</MenuItem>
                </TextField>
              </Grid>

              {formularioState.victim?.requested_by !== "A" && (
              <>
                <Grid item xs={12} sm={6}>
                  <TextField
                    required
                    sx={{ borderRadius: "30px" }}
                    fullWidth
                    size="small"
                    id="name_representative"
                    label="NOMBRE"
                    variant="outlined"
                    error={!!errors.representative?.name}
                    helperText={errors.representative?.name || ""}
                    value={formularioState.representative.name}
                    onChange={(e) =>
                      handleChange("representative", "name", uppercaseText(e.target.value))
                    }                  
                  />
                </Grid>
                <Grid item xs={12} sm={6}>
                  <TextField
                    required
                    sx={{ borderRadius: "30px" }}
                    fullWidth
                    size="small"
                    id="first_lastname_representative"
                    label="A.PATERNO"
                    variant="outlined"
                    error={!!errors.representative?.first_lastname}
                    helperText={errors.representative?.first_lastname || ""}
                    value={formularioState.representative.first_lastname}
                    onChange={(e) =>
                      handleChange("representative", "first_lastname", uppercaseText(e.target.value))
                    } 
                    />
                </Grid>
                <Grid item xs={12} sm={6}>
                  <TextField
                    sx={{ borderRadius: "30px" }}
                    fullWidth
                    size="small"
                    id="second_lastname_representative"
                    label="A.MATERNO"
                    variant="outlined"
                    value={formularioState.representative.second_lastname}
                    onChange={(e) =>
                      handleChange("representative", "second_lastname", uppercaseText(e.target.value))
                    } 
                  />
                </Grid>
                <Grid item xs={12} sm={6}>
                  <TextField
                    sx={{ borderRadius: "30px" }}
                    fullWidth
                    size="small"
                    id="relationship_representative"
                    label="PARENTESCO /RELACIÓN AfECTIVA"
                    variant="outlined"
                    value={formularioState.representative.relationship}
                    onChange={(e) =>
                      handleChange("representative", "relationship", uppercaseText(e.target.value))
                    }
                  />
                </Grid>
                {formularioState.victim?.requested_by === "C" && (
                  <Grid item xs={12} sm={6}>
                    <TextField
                      sx={{ borderRadius: "30px" }}
                      fullWidth
                      size="small"
                      id="post_representative"
                      label="CARGO"
                      variant="outlined"
                      value={formularioState.representative.post}
                      onChange={(e) =>
                        handleChange("representative", "post", uppercaseText(e.target.value))
                      }
                    />
                  </Grid>
                )}
                {formularioState.victim?.requested_by === "C" && (
                  <Grid item xs={12} sm={6}>
                    <TextField
                      sx={{ borderRadius: "30px" }}
                      fullWidth
                      size="small"
                      id="dependence_representative"
                      label="DEPENDENCIA O INSTITUCION"
                      variant="outlined"
                      value={formularioState.representative.dependence}
                      onChange={(e) =>
                        handleChange("representative", "dependence", uppercaseText(e.target.value))
                      }
                    />
                  </Grid>
                )}
                <Grid item xs={12} sm={6}>
                  <TextField
                    required
                    sx={{ borderRadius: "30px" }}
                    fullWidth
                    size="small"
                    id="phone_representative"
                    label="TELÉFONO DE MOVIL"
                    error={!!errors.representative?.phone}
                    helperText={errors.representative?.phone || ""}
                    variant="outlined"
                    value={formularioState.representative.phone || ""}
                    onChange={(e) =>
                      handleChange("representative", "phone", uppercaseText(e.target.value))
                    }
                    onKeyPress={onlyNumber}
                    inputProps={{ maxLength: 10 }}
                  />
                </Grid>
                <Grid item xs={12} sm={6}>
                  <TextField
                    sx={{ borderRadius: "30px" }}
                    fullWidth
                    size="small"
                    id="landline_phone_representative"
                    label="TELÉFONO FIJO"
                    error={!!errors.representative?.landline_phone}
                    helperText={errors.representative?.landline_phone || ""}
                    variant="outlined"
                    value={formularioState.representative.landline_phone || ""}
                    onChange={(e) =>
                      handleChange("representative", "landline_phone", uppercaseText(e.target.value))
                    }
                    onKeyPress={onlyNumber}
                    inputProps={{ maxLength: 10 }}
                  />
                </Grid>
                <Grid item xs={12} sm={6}>
                  <TextField
                    sx={{ borderRadius: "30px" }}
                    fullWidth
                    size="small"
                    id="email_representative"
                    label="EMAIL"
                    variant="outlined"
                    error={!!errors.representative?.email}
                    helperText={errors.representative?.email || ""}
                    value={formularioState.representative.email || ""}
                    onChange={(e) =>
                      handleChange("representative", "email", uppercaseText(e.target.value))
                    }
                  />
                </Grid>
                <Grid item xs={12} sm={6}>
                  <TextField
                    sx={{ borderRadius: "30px" }}
                    fullWidth
                    size="small"
                    id="other_information_representative"
                    label="OTROS DATOS DE CONTACTO"
                    variant="outlined"
                    value={formularioState.representative.other_information}
                    onChange={(e) =>
                      handleChange("representative", "other_information", uppercaseText(e.target.value))
                    }                  
                  />
                </Grid> 
              </>
              )}

            
              <Grid item xs={12}>
                <Typography
                  className="my-3"
                  align="center"
                  fontWeight="bold"
                >
                  II TIPO Y DATOS DE LA VÍCTIMA                
                </Typography>
              </Grid>
              <Grid item xs={12} sm={6}>
                <TextField 
                  required
                  fullWidth size="small" 
                  label="TIPO DE VÍCTIMA" 
                  variant="outlined" 
                  select 
                  error={!!errors.victim?.victim_type} 
                  helperText={errors.victim?.victim_type || ""}  
                  value={formularioState.victim.victim_type}
                  onChange={(e) =>
                  handleChange("victim", "victim_type", uppercaseText(e.target.value))
                  } 
                >
                  <MenuItem value="DIRECTA">DIRECTA</MenuItem>
                  <MenuItem value="INDIRECTA">INDIRECTA</MenuItem>
                  <MenuItem value="POTENCIAL">POTENCIAL</MenuItem>
                </TextField>
              </Grid>
              <Grid item xs={12} sm={6}>
                <TextField
                  required
                  sx={{ borderRadius: "30px" }}
                  fullWidth
                  size="small"
                  id="name_victim"
                  label="NOMBRE"
                  variant="outlined"
                  error={!!errors.victim?.name}
                  helperText={errors.victim?.name || ""}
                  value={formularioState.victim.name}
                  onChange={(e) =>
                    handleChange("victim", "name", uppercaseText(e.target.value))
                  }                  
                />
              </Grid>
              <Grid item xs={12} sm={6}>
                <TextField
                  required
                  sx={{ borderRadius: "30px" }}
                  fullWidth
                  size="small"
                  id="first_lastname_victim"
                  label="A.PATERNO"
                  variant="outlined"
                  error={!!errors.victim?.first_lastname}
                  helperText={errors.victim?.first_lastname || ""}
                  value={formularioState.victim.first_lastname}
                  onChange={(e) =>
                    handleChange("victim", "first_lastname", uppercaseText(e.target.value))
                  } 
                />
              </Grid>
              <Grid item xs={12} sm={6}>
                <TextField
                  sx={{ borderRadius: "30px" }}
                  fullWidth
                  size="small"
                  id="second_lastname_victim"
                  label="A.MATERNO"
                  variant="outlined"
                  value={formularioState.victim.second_lastname}
                  onChange={(e) =>
                    handleChange("victim", "second_lastname", uppercaseText(e.target.value))
                  } 
                />
              </Grid>
              <Grid item xs={12} sm={6}>
                <Autocomplete
                  fullWidth
                  size="small"
                  id="degree_id_victim"
                  sx={{
                    borderRadius: "30px",
                  }}
                  options={state.titulos || []}
                  getOptionLabel={(option) => option.name || ""}
                  value={
                    state.titulos.find(
                      (option) => option.id === formularioState.victim.degree_id
                    ) || null
                  }
                  onChange={(e, newValue) =>
                    handleChange("victim", "degree_id", newValue?.id || "")
                  }
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      label="TITULO"
                    />
                  )}
                />
              </Grid>
              <Grid item xs={12} sm={6}>
                <LocalizationProvider dateAdapter={AdapterDayjs}>
                  <DatePicker
                    label="FECHA DE NACIMIENTO"
                    id="birthdate_victim"
                    style={{ width: "40%", marginLeft: "10px" }}
                    value={
                      formularioState.victim.birthdate
                        ? dayjs(formularioState.victim.birthdate)
                        : null
                    }
                    onChange={(newValue) =>
                      handleChange(
                        "victim",
                        "birthdate",
                        newValue ? newValue.format("YYYY-MM-DD") : ""
                      )
                    }
                    format="DD/MM/YYYY"
                    maxDate={dayjs()}
                    slotProps={{
                      textField: {
                        fullWidth: true,
                        size: "small",
                        error: !!errors.birthdate,
                        helperText: errors.birthdate || "",
                      },
                    }}
                  />
                </LocalizationProvider>
              </Grid>
              <Grid item xs={12} sm={6}>
                <TextField
                  required
                  sx={{ borderRadius: "30px" }}
                  fullWidth
                  size="small"
                  id="age_victim"
                  label="EDAD"
                  variant="outlined"
                  onKeyPress={onlyNumber}
                  inputProps={{ maxLength: 3 }}
                  error={!!errors.victim?.age}
                  helperText={errors.victim?.age || ""}
                  value={formularioState.victim.age}
                  onChange={(e) =>
                    handleChange("victim", "age", uppercaseText(e.target.value))
                  } 
                />
              </Grid>
              <Grid item xs={12} sm={6}>
                <TextField
                  required
                  sx={{ borderRadius: "30px" }}
                  fullWidth
                  size="small"
                  id="sex_victim"
                  label="SEXO"
                  variant="outlined"
                  select
                  error={!!errors.victim?.sex}
                  helperText={errors.victim?.sex || ""}
                  value={formularioState.victim.sex}
                  onChange={(e) =>
                    handleChange("victim", "sex", uppercaseText(e.target.value))
                  } 
                >
                  <MenuItem key={0} value={"FEMENINO"}>
                    FEMENINO
                  </MenuItem>
                  <MenuItem key={1} value={"MASCULINO"}>
                    MASCULINO
                  </MenuItem>
                  <MenuItem key={2} value={"INTERSEXUAL"}>
                    INTERSEXUAL
                  </MenuItem>
                </TextField>
              </Grid>
              <Grid item xs={12} sm={6}>
                <TextField
                  required
                  fullWidth
                  size="small"
                  id="nationality_victim"
                  label="NACIONALIDAD"
                  variant="outlined"
                  error={!!errors.victim?.nationality}
                  helperText={errors.victim?.nationality || ""}
                  value={formularioState.victim.nationality}
                  onChange={(e) =>
                    handleChange("victim", "nationality", uppercaseText(e.target.value))
                  } 
                />
              </Grid>
              <Grid item xs={12} sm={6}>
                <TextField
                  sx={{ borderRadius: "30px" }}
                  fullWidth
                  size="small"
                  id="curp_victim"
                  label="CURP"
                  variant="outlined"
                  error={!!errors.victim?.curp}
                  helperText={errors.victim?.curp || ""}
                  value={formularioState.victim.curp}
                  onChange={(e) =>
                    handleChange("victim", "curp", uppercaseText(e.target.value))
                  } 
                  inputProps={{ maxLength: 18 }}
                />
              </Grid>
              <Grid item xs={12} sm={6}>
                <TextField
                  required
                  sx={{ borderRadius: "30px" }}
                  fullWidth
                  size="small"
                  id="place_birth_country_victim"
                  label="PAÍS DE NACIMIENTO:"
                  variant="outlined"
                  error={!!errors.victim?.place_birth_country}
                  helperText={errors.victim?.place_birth_country || ""}
                  value={formularioState.victim.place_birth_country}
                  onChange={(e) =>
                    handleChange("victim", "place_birth_country", uppercaseText(e.target.value))
                  } 
                />
              </Grid>
              <Grid item xs={12} sm={6}>
                <TextField
                  required
                  sx={{ borderRadius: "30px" }}
                  fullWidth
                  size="small"
                  id="place_birth_entity_victim"
                  label="ENTIDAD FEDERATIVA DE NACIMIENTO: "
                  variant="outlined"
                  error={!!errors.victim?.place_birth_entity}
                  helperText={errors.victim?.place_birth_entity || ""}
                  value={formularioState.victim.place_birth_entity}
                  onChange={(e) =>
                    handleChange("victim", "place_birth_entity", uppercaseText(e.target.value))
                  } 
                />
              </Grid>
              <Grid item xs={12} sm={6}>
                <TextField
                  required
                  sx={{ borderRadius: "30px" }}
                  fullWidth
                  size="small"
                  id="place_birth_municipality_victim"
                  label="LUGAR DE NACIMIENTO: DELEGACIÓN O MUNICIPIO"
                  variant="outlined"
                  error={!!errors.victim?.place_birth_municipality}
                  helperText={errors.victim?.place_birth_municipality || ""}
                  value={formularioState.victim.place_birth_municipality}
                  onChange={(e) =>
                    handleChange("victim", "place_birth_municipality", uppercaseText(e.target.value))
                  } 
                />
              </Grid>
              <Grid item xs={12} sm={6}>
                <TextField
                  sx={{ borderRadius: "30px" }}
                  fullWidth
                  size="small"
                  id="place_birth_town_victim"
                  label="LUGAR DE NACIMIENTO: POBLACIÓN O COMUNIDAD"
                  variant="outlined"
                  error={!!errors.victim?.place_birth_town}
                  helperText={errors.victim?.place_birth_town || ""}
                  value={formularioState.victim.place_birth_town}
                  onChange={(e) =>
                    handleChange("victim", "place_birth_town", uppercaseText(e.target.value))
                  } 
                />
              </Grid>
              <Grid item xs={12}>
                <Typography
                  className="my-3"
                  align="center"
                  fontWeight="bold"
                >
                  DOMICILIO ACTUAL DE LA VÍCTIMA               
                </Typography>
              </Grid>
              <Grid item xs={12} sm={6}>
                <TextField
                  required
                  sx={{ borderRadius: "30px" }}
                  fullWidth
                  size="small"
                  id="marital_status_victim"
                  label="ESTADO CIVIL"
                  variant="outlined"
                  select
                  error={!!errors.victim?.marital_status}
                  helperText={errors.victim?.marital_status || ""}
                  value={formularioState.victim.marital_status}
                  onChange={(e) =>
                    handleChange("victim", "marital_status", uppercaseText(e.target.value))
                  } 
                >
                  <MenuItem key={0} value={"SOLTERO/A"}>
                    SOLTERO/A
                  </MenuItem>
                  <MenuItem key={1} value={"CASADO/A"}>
                    CASADO/A
                  </MenuItem>
                  <MenuItem key={2} value={"DIVORCIADO/A"}>
                    DIVORCIADO/A
                  </MenuItem>
                  <MenuItem key={2} value={"VIUDO/A"}>
                    VIUDO/A
                  </MenuItem>
                  <MenuItem key={2} value={"UNION LIBRE"}>
                    UNION LIBRE
                  </MenuItem>
                  <MenuItem key={2} value={"CONCUBINATO"}>
                    CONCUBINATO
                  </MenuItem>
                  <MenuItem key={2} value={"SEPARADO/A"}>
                    SEPARADO/A
                  </MenuItem>
                </TextField>
              </Grid>
              <Grid item xs={12} sm={6}>
                <TextField
                  sx={{ borderRadius: "30px" }}
                  fullWidth
                  size="small"
                  id="cp_victim"
                  label="CODIGO POSTAL"
                  variant="outlined"
                  value={formularioState.victim.cp}
                  onChange={(e) =>
                    handleChange("victim", "cp", uppercaseText(e.target.value))
                  } 
                  onKeyPress={onlyNumber}
                  inputProps={{ maxLength: 5 }}
                />
              </Grid>
              <Grid item xs={12} sm={6}>
                <TextField
                  sx={{ borderRadius: "30px" }}
                  fullWidth
                  size="small"
                  id="colony_victim"
                  label="COLONIA"
                  variant="outlined"
                  value={formularioState.victim.colony}
                  onChange={(e) =>
                    handleChange("victim", "colony", uppercaseText(e.target.value))
                  } 
                />
              </Grid>
              <Grid item xs={12} sm={6}>
                <Autocomplete
                  options={state.municipios || []}
                  getOptionLabel={(option) => option.name || ""}
                  fullWidth
                  size="small"
                  id="municipality_id_victim"
                  sx={{borderRadius: "30px",}}
                  value={
                    state.municipios.find(
                      (option) => option.id === formularioState.victim.municipality_id
                    ) || null
                  }
                  onChange={(event, newValue) => handleMunicipality_id(newValue)}
                  renderInput={(params) => (
                    <TextField
                      error={!!errors.victim?.municipality_id}
                      helperText={errors.victim?.municipality_id || ""}
                      {...params}
                      label="MUNICIPIO"
                    />
                  )}
                />
              </Grid>
              <Grid item xs={12} sm={6}>
                <TextField 
                  fullWidth size="small" 
                  label="LOCALIDAD" variant="outlined" 
                  select 
                  error={!!errors.victim?.locality_id} 
                  helperText={errors.victim?.locality_id || ""} 
                  value={formularioState.victim.locality_id || ""}
                  onChange={(e) =>
                    handleChange("victim", "locality_id", uppercaseText(e.target.value))
                  } 
                >
                  {state.localidades?.length > 0 ? (
                    state.localidades.map((option) => (
                      <MenuItem key={option.id} value={option.id}>
                        {option.name}
                      </MenuItem>
                    ))
                  ) : (
                    <MenuItem key={0} value="">
                      SIN LOCALIDADES
                    </MenuItem>
                  )}
                </TextField>
              </Grid>
              <Grid item xs={12} sm={6}>
                <TextField
                  sx={{ borderRadius: "30px" }}
                  fullWidth
                  size="small"
                  id="street_victim"
                  label="CALLE"
                  variant="outlined"
                  value={formularioState.victim.street || ""}
                  onChange={(e) =>
                    handleChange("victim", "street", uppercaseText(e.target.value))
                  } 
                />
              </Grid>
              <Grid item xs={12} sm={6}>
                <TextField
                  sx={{ borderRadius: "30px" }}
                  fullWidth
                  size="small"
                  id="number_victim"
                  label="NO."
                  variant="outlined"
                  value={formularioState.victim.number || ""}
                  onChange={(e) =>
                    handleChange("victim", "number", uppercaseText(e.target.value))
                  } 
                  inputProps={{ maxLength: 20 }}
                />
              </Grid>
              <Grid item xs={12} sm={6}>
                <TextField
                  required
                  sx={{ borderRadius: "30px" }}
                  fullWidth
                  size="small"
                  id="federal_entity_victim"
                  label="ENTIDAD FEDERATIVA"
                  variant="outlined"
                  error={!!errors.victim?.federal_entity}
                  helperText={errors.victim?.federal_entity || ""}
                  value={formularioState.victim.federal_entity || ""}
                  onChange={(e) =>
                    handleChange("victim", "federal_entity", uppercaseText(e.target.value))
                  } 
                />
              </Grid>
              <Grid item xs={12} sm={6}>
                <TextField
                  required
                  sx={{ borderRadius: "30px" }}
                  fullWidth
                  size="small"
                  id="phone_victim"
                  label="TELÉFONO"
                  variant="outlined"
                  error={!!errors.victim?.phone}
                  helperText={errors.victim?.phone || ""}
                  value={formularioState.victim.phone || ""}
                  onChange={(e) =>
                    handleChange("victim", "phone", uppercaseText(e.target.value))
                  }
                  onKeyPress={onlyNumber}
                  inputProps={{ maxLength: 10 }}
                />
              </Grid>
              <Grid item xs={12} sm={6}>
                <TextField
                  sx={{ borderRadius: "30px" }}
                  fullWidth
                  size="small"
                  id="email_victim"
                  label="EMAIL"
                  variant="outlined"
                  error={!!errors.victim?.email}
                  helperText={errors.victim?.email || ""}
                  value={formularioState.victim.email || ""}
                  onChange={(e) =>
                    handleChange("victim", "email", uppercaseText(e.target.value))
                  }
                />
              </Grid>
            </>
          )}

          {state.step === 1 && (
            <>
              <Grid item xs={12}>
                <Typography
                  className="my-3"
                  align="center"
                  fontWeight="bold"
                >
                  III RELACIÓN DE LA VÍCTIMA INDIRECTA CON LA VÍCTIMA DIRECTA
                </Typography>
              </Grid>

              {/* Renderizar dinámicamente cada víctima indirecta */}
              {formularioState.indirect_victims.map((victim, index) => (
                <Grid 
                  container 
                  spacing={3} 
                  key={index}
                  sx={{ mb: 2, p: 1.5, borderRadius: "8px", margin: "5px" }}
                >

                  <Grid item xs={12} sm={6}>
                    <TextField
                      sx={{ borderRadius: "30px" }}
                      fullWidth
                      size="small"
                      id={`fullname_indirect_victim_${index}`}
                      label="NOMBRE COMPLETO DE LA VÍCTIMA DIRECTA"
                      variant="outlined"
                      value={victim.full_name}
                      onChange={(e) =>
                        handleIndirectVictimChange(index, "full_name", uppercaseText(e.target.value))
                      }
                    />
                  </Grid>
                  <Grid item xs={12} sm={6}>
                    <TextField
                      sx={{ borderRadius: "30px" }}
                      fullWidth
                      size="small"
                      id={`relationship_indirect_victim_${index}`}
                      label="RELACIÓN CON LA VÍCTIMA DIRECTA"
                      variant="outlined"
                      value={victim.relationship}
                      onChange={(e) =>
                        handleIndirectVictimChange(index, "relationship", uppercaseText(e.target.value))
                      }
                    />
                  </Grid>
                  {/* Botón para eliminar  */}
                  {formularioState.indirect_victims.length > 1 && (
                    <Grid item xs={12}>
                      <Button
                        variant="outlined"
                        color="error"
                        size="small"
                        onClick={() => handleRemoveIndirectVictim(index)}
                      >
                        - Eliminar
                      </Button>
                    </Grid>
                  )}
                </Grid>
              ))}

              {/* Botón para agregar nueva víctima indirecta */}
              <Grid item xs={12}>
                <Button
                  variant="contained"
                  color="primary"
                  size="small"
                  onClick={handleAddIndirectVictim}
                >
                  + Agregar
                </Button>
              </Grid>

              <Grid item xs={12}>
                <Typography
                  className="my-3"
                  align="center"
                  fontWeight="bold"
                >
                  IV IDENTIFICACIÓN DE LA VÍCTIMA
                </Typography>
              </Grid>
              <Grid item xs={12} sm={6}>
                <TextField 
                  required
                  fullWidth size="small" 
                  label="PRESENTA IDENTIFICACIÓN" 
                  variant="outlined" 
                  select 
                  error={!!errors.victim?.has_identification} 
                  helperText={errors.victim?.has_identification || ""}  
                  value={formularioState.victim.has_identification}
                  onChange={(e) =>
                  handleChange("victim", "has_identification", stringToBoolean(e.target.value))
                  } 
                >
                  <MenuItem value={true}>SI</MenuItem>
                  <MenuItem value={false}>NO</MenuItem>
                </TextField>
              </Grid>
              {formularioState.victim?.has_identification && (
              <>
                <Grid item xs={12} sm={6}>
                  <TextField
                    required
                    sx={{ borderRadius: "30px" }} 
                    fullWidth size="small" 
                    label="TIPO DE IDENTIFICACIÓN" 
                    variant="outlined" 
                    select 
                    error={!!errors.victim?.identification_type} 
                    helperText={errors.victim?.identification_type || ""}  
                    value={formularioState.victim.identification_type}
                    onChange={(e) =>
                    handleChange("victim", "identification_type", uppercaseText(e.target.value))
                    } 
                  >
                    <MenuItem value="CREDENCIAL DE ELECTOR">CREDENCIAL DE ELECTOR</MenuItem>
                    <MenuItem value="CARTILLA DEL SERVICIO MILITAR">CARTILLA DEL SERVICIO MILITAR</MenuItem>
                    <MenuItem value="PASAPORTE">PASAPORTE</MenuItem>
                    <MenuItem value="CEDULA PROFESIONAL">CEDULA PROFESIONAL</MenuItem>
                    <MenuItem value="CREDENCIAL OFICIAL EXPEDIDA POR EL IMSS O ISSSTE">CREDENCIAL OFICIAL EXPEDIDA POR EL IMSS O ISSSTE</MenuItem>
                    <MenuItem value="CERTIFICADO O CONSTANCIA DE ESTUDIOS">CERTIFICADO O CONSTANCIA DE ESTUDIOS</MenuItem>
                    <MenuItem value="CONSTANCIA DE RESIDENCIA EXPEDIDA POR AUTORIDAD LOCAL">CONSTANCIA DE RESIDENCIA EXPEDIDA POR AUTORIDAD LOCAL</MenuItem>
                    <MenuItem value="TARJETA DE RESIDENCIA TEMPORAL">TARJETA DE RESIDENCIA TEMPORAL</MenuItem>
                    <MenuItem value="TARJETA DE RESIDENCIA PERMANENTE">TARJETA DE RESIDENCIA PERMANENTE</MenuItem>
                  </TextField>
                </Grid>
                <Grid item xs={12} sm={6}>
                  <TextField
                    required
                    sx={{ borderRadius: "30px" }}
                    fullWidth
                    size="small"
                    id="identification_number_victim"
                    label="NÚMERO DEL DOCUMENTO PROBATORIO"
                    variant="outlined"
                    error={!!errors.victim?.identification_number} 
                    helperText={errors.victim?.identification_number || ""} 
                    value={formularioState.victim.identification_number}
                    onChange={(e) =>
                      handleChange("victim", "identification_number", uppercaseText(e.target.value))
                    } 
                    inputProps={{ maxLength: 30 }}
                  />
                </Grid>
              </>
              )}
              <Grid item xs={12}>
                <Typography
                  className="my-3"
                  align="center"
                  fontWeight="bold"
                >
                  V LUGAR Y FECHA DE LOS HECHOS
                </Typography>
              </Grid>
              <Grid item xs={12} sm={6}>
                <TextField
                  sx={{ borderRadius: "30px" }}
                  fullWidth
                  size="small"
                  id="street_facts"
                  label="CALLE"
                  variant="outlined"
                  value={formularioState.facts.street}
                  onChange={(e) =>
                    handleChange("facts", "street", uppercaseText(e.target.value))
                  }                 />
              </Grid>
              <Grid item xs={12} sm={6}>
                <TextField
                  sx={{ borderRadius: "30px" }}
                  fullWidth
                  size="small"
                  id="external_number_facts"
                  label="NÚMERO EXTERIOR"
                  variant="outlined"
                  value={formularioState.facts.external_number}
                  onChange={(e) =>
                    handleChange("facts", "external_number", uppercaseText(e.target.value)) 
                  }
                  inputProps={{ maxLength: 10 }}
                />
              </Grid>
              <Grid item xs={12} sm={6}>
                <TextField
                  sx={{ borderRadius: "30px" }}
                  fullWidth
                  size="small"
                  id="internal_number_facts"
                  label="NÚMERO INTERIOR"
                  variant="outlined"
                  value={formularioState.facts.internal_number}
                  onChange={(e) =>
                    handleChange("facts", "internal_number", uppercaseText(e.target.value))
                  }
                  inputProps={{ maxLength: 10 }}
                />
              </Grid>
              <Grid item xs={12} sm={6}>
                <TextField
                  sx={{ borderRadius: "30px" }}
                  fullWidth
                  size="small"
                  id="cp_facts"
                  label="CÓDIGO POSTAL"
                  variant="outlined"
                  value={formularioState.facts.cp}
                  onChange={(e) =>
                    handleChange("facts", "cp", uppercaseText(e.target.value))
                  }
                  onKeyPress={onlyNumber}
                  inputProps={{ maxLength: 5 }}
                />
              </Grid>
              <Grid item xs={12} sm={6}>
                <TextField
                  sx={{ borderRadius: "30px" }}
                  fullWidth
                  size="small"
                  id="colony_facts"
                  label="COLONIA"
                  variant="outlined"
                  value={formularioState.facts.colony}
                  onChange={(e) =>
                    handleChange("facts", "colony", uppercaseText(e.target.value))
                  }
                />
              </Grid>
              <Grid item xs={12} sm={6}>
                <TextField
                  required
                  sx={{ borderRadius: "30px" }}
                  fullWidth
                  size="small"
                  id="locality_facts"
                  label="LOCALIDAD"
                  variant="outlined"
                  error={!!errors.facts?.locality}
                  helperText={errors.facts?.locality || ""}
                  value={formularioState.facts.locality}
                  onChange={(e) =>
                    handleChange("facts", "locality", uppercaseText(e.target.value))
                  }
                />
              </Grid>
              <Grid item xs={12} sm={6}>
                <TextField
                  required
                  sx={{ borderRadius: "30px" }}
                  fullWidth
                  size="small"
                  id="municipality_facts"
                  label="DELEGACIÓN O MUNICIPIO"
                  variant="outlined"
                  error={!!errors.facts?.municipality}
                  helperText={errors.facts?.municipality || ""}
                  value={formularioState.facts.municipality}
                  onChange={(e) =>
                    handleChange("facts", "municipality", uppercaseText(e.target.value))
                  }
                />
              </Grid>
              <Grid item xs={12} sm={6}>
                <TextField
                  required
                  sx={{ borderRadius: "30px" }}
                  fullWidth
                  size="small"
                  id="federal_entity_facts"
                  label="ENTIDAD FEDERATIVA"
                  variant="outlined"
                  error={!!errors.facts?.federal_entity}
                  helperText={errors.facts?.federal_entity || ""}
                  value={formularioState.facts.federal_entity}
                  onChange={(e) =>
                    handleChange("facts", "federal_entity", uppercaseText(e.target.value))
                  }
                />
              </Grid>
              <Grid item xs={12} sm={6}>
                <LocalizationProvider dateAdapter={AdapterDayjs}>
                  <DatePicker
                    required
                    label="FECHA"
                    id="date_facts"
                    style={{ width: "40%", marginLeft: "10px" }}
                    value={
                      formularioState.facts.facts_date
                        ? dayjs(formularioState.facts.facts_date)
                        : null
                    }
                    onChange={(newValue) =>
                      handleChange(
                        "facts",
                        "facts_date",
                        newValue ? newValue.format("YYYY-MM-DD") : ""
                      )
                    }
                    format="DD/MM/YYYY"
                    maxDate={dayjs()}
                    slotProps={{
                      textField: {
                        fullWidth: true,
                        size: "small",
                      },
                    }}
                  />
                </LocalizationProvider>
              </Grid>
              <Grid item xs={12}>
                <TextField
                  required
                  sx={{ borderRadius: "30px" }}
                  fullWidth
                  id="facts_facts"
                  label="RELATO DE LOS HECHOS"
                  variant="outlined"
                  multiline
                  rows={8}
                  value={formularioState.facts.facts}
                  onChange={(e) =>
                    handleChange("facts", "facts", uppercaseText(e.target.value))
                  }
                  error={!!errors.facts?.facts}
                  helperText={errors.facts?.facts || ""}
                />
              </Grid>

            </>
          )}

          {state.step === 2 && (
            <>
               <Grid item xs={12}>
                <Typography
                  className="my-3"
                  align="center"
                  fontWeight="bold"
                >
                  VI OBSERVACIONES PRELIMINARES DE QUIEN LLENA EL FORMATO
                </Typography>
              </Grid>

              <Grid item xs={12} sm={6}>
                <TextField
                  required 
                  fullWidth 
                  size="small" 
                  label="TIPO DE DAÑO SUFRIDO" 
                  variant="outlined" 
                  select 
                  SelectProps={{
                    multiple: true,
                    renderValue: (selected) => selected.join(", "),
                  }}
                  error={!!errors.preliminary_observations?.damage_type} 
                  helperText={errors.preliminary_observations?.damage_type || ""}  
                  value={normalizeMultiSelect(formularioState.preliminary_observations.damage_type)}
                  onChange={(e) =>
                  handleChange("preliminary_observations", "damage_type", normalizeMultiSelect(e.target.value).map(uppercaseText))
                  } 
                >
                  <MenuItem value="FÍSICO">FÍSICO</MenuItem>
                  <MenuItem value="PSICOLÓGICO">PSICOLÓGICO</MenuItem>
                  <MenuItem value="SEXUAL">SEXUAL</MenuItem>
                  <MenuItem value="OTRO">OTRO</MenuItem>
                </TextField>
              </Grid>
              {normalizeMultiSelect(formularioState.preliminary_observations?.damage_type).includes("OTRO") && (
              <>              
                <Grid item xs={12} sm={6}>
                  <TextField
                    required
                    sx={{ borderRadius: "30px" }}
                    fullWidth
                    size="small"
                    id="damage_other_preliminary_observations"
                    label="OTRO"
                    variant="outlined"
                    error={!!errors.preliminary_observations?.damage_other}
                    helperText={errors.preliminary_observations?.damage_other || ""}
                    value={formularioState.preliminary_observations.damage_other}
                    onChange={(e) =>
                      handleChange("preliminary_observations", "damage_other", uppercaseText(e.target.value))
                    }
                  />
                </Grid>
              </>
              )}
              <Grid item xs={12}>
                <TextField
                  sx={{ borderRadius: "30px" }}
                  fullWidth
                  id="authority_notes_preliminary_observations"
                  label="NOTAS DE LA AUTORIDAD QUE APOYA EN EL LLENADO DEL FUD"
                  variant="outlined"
                  multiline
                  rows={4}
                  value={formularioState.preliminary_observations.authority_notes}
                  onChange={(e) =>
                    handleChange("preliminary_observations", "authority_notes", uppercaseText(e.target.value))
                  }
                />
              </Grid>
              <Grid item xs={12} sm={6}>
                <TextField 
                  required
                  fullWidth 
                  size="small" 
                  label="VIOLENCIA DE GÉNERO" 
                  variant="outlined" 
                  select 
                  error={!!errors.preliminary_observations?.gender_violence} 
                  helperText={errors.preliminary_observations?.gender_violence || ""}  
                  value={formularioState.preliminary_observations.gender_violence}
                  onChange={(e) =>
                    handleChange("preliminary_observations", "gender_violence", stringToBoolean(e.target.value))
                  }
                >
                  <MenuItem value={true}>SI</MenuItem>
                  <MenuItem value={false}>NO</MenuItem>
                </TextField>
              </Grid>
              
              {formularioState.preliminary_observations?.gender_violence && (
              <>
                <Grid item xs={12} sm={6}>
                  <TextField 
                    fullWidth 
                    size="small" 
                    label="TIPO DE VIOLENCIA" 
                    variant="outlined" 
                    select 
                    SelectProps={{
                      multiple: true,
                      renderValue: (selected) => selected.join(", "),
                    }}
                    error={!!errors.preliminary_observations?.violence_type} 
                    helperText={errors.preliminary_observations?.violence_type || ""}  
                    value={normalizeMultiSelect(formularioState.preliminary_observations.violence_type)}
                    onChange={(e) =>
                    handleChange("preliminary_observations", "violence_type", normalizeMultiSelect(e.target.value).map(uppercaseText))
                    } 
                  >
                    <MenuItem value="PSICOLÓGICA">PSICOLÓGICA</MenuItem>
                    <MenuItem value="FÍSICA">FÍSICA</MenuItem>
                    <MenuItem value="ECONÓMICA">ECONÓMICA</MenuItem>
                    <MenuItem value="PATRIMONIAL">PATRIMONIAL</MenuItem>
                    <MenuItem value="SEXUAL">SEXUAL</MenuItem>
                    <MenuItem value="OBSTÉTRICA">OBSTÉTRICA</MenuItem>
                    <MenuItem value="FEMINICIDA">FEMINICIDA</MenuItem>
                    <MenuItem value="OTRA">OTRA</MenuItem>
                  </TextField>
                </Grid>
              
                {normalizeMultiSelect(formularioState.preliminary_observations?.violence_type).includes("OTRA") && (
                <>
                  <Grid item xs={12} sm={6}>
                    <TextField
                      sx={{ borderRadius: "30px" }}
                      fullWidth
                      size="small"
                      id="violence_other_preliminary_observations"
                      label="OTRA"
                      variant="outlined"
                      error={!!errors.preliminary_observations?.violence_other}
                      helperText={errors.preliminary_observations?.violence_other || ""}
                      value={formularioState.preliminary_observations.violence_other}
                      onChange={(e) =>
                        handleChange("preliminary_observations", "violence_other", uppercaseText(e.target.value))
                      }
                    />
                  </Grid>
                </>
                )}
              </>
              )}

              <Grid item xs={12}>
                <Typography
                  className="my-3"
                  align="center"
                  fontWeight="bold"
                >
                  VII AUTORIDADES QUE HAN CONOCIDO DE LOS HECHOS
                </Typography>
              </Grid>
              {/* investigación ministerial */}
              <Grid item xs={12}>
                <Typography
                  className="my-3"
                  fontWeight="bold"
                >
                  INVESTIGACIÓN MINISTERIAL
                </Typography>
              </Grid>              
              <Grid item xs={12} sm={6}>
                <TextField 
                  required
                  fullWidth 
                  size="small" 
                  label="¿DENUNCIÓ ANTE EL MINISTERIO PÚBLICO?" 
                  variant="outlined" 
                  select 
                  error={!!errors.authorities?.reported_to_mp} 
                  helperText={errors.authorities?.reported_to_mp || ""}  
                  value={formularioState.authorities.reported_to_mp}
                  onChange={(e) =>
                  handleChange("authorities", "reported_to_mp", stringToBoolean(e.target.value))
                  } 
                >
                  <MenuItem value={true}>SI</MenuItem>
                  <MenuItem value={false}>NO</MenuItem>
                </TextField>
              </Grid>
              {formularioState.authorities?.reported_to_mp && (
                <>
                  <Grid item xs={12} sm={6}>
                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                      <DatePicker
                        label="FECHA"
                      id="mp_date_authorities"
                      style={{ width: "40%", marginLeft: "10px" }}
                      value={
                        formularioState.authorities.mp_date
                          ? dayjs(formularioState.authorities.mp_date)
                          : null
                      }
                      onChange={(newValue) =>
                        handleChange(
                          "authorities",
                          "mp_date",
                          newValue ? newValue.format("YYYY-MM-DD") : ""
                        )
                      }
                      format="DD/MM/YYYY"
                      maxDate={dayjs()}
                      slotProps={{
                        textField: {
                          fullWidth: true,
                          size: "small",
                          // error: !!errors.mp_date,
                          // helperText: errors.mp_date || "",
                        },
                      }}
                    />
                  </LocalizationProvider>
                  </Grid>
                  <Grid item xs={12} sm={6}>
                    <TextField 
                      required
                      fullWidth 
                      size="small" 
                      label="COMPETENCIA" 
                      variant="outlined" 
                      select 
                      error={!!errors.authorities?.mp_jurisdiction}
                      helperText={errors.authorities?.mp_jurisdiction || ""}  
                      value={formularioState.authorities.mp_jurisdiction}
                      onChange={(e) =>
                      handleChange("authorities", "mp_jurisdiction", uppercaseText(e.target.value))
                      } 
                    >
                      <MenuItem value="FEDERAL">FEDERAL</MenuItem>
                      <MenuItem value="LOCAL">LOCAL</MenuItem>
                    </TextField>
                  </Grid>
                  <Grid item xs={12} sm={6}>
                    <TextField
                      required
                      sx={{ borderRadius: "30px" }}
                      fullWidth
                      size="small"
                      id="mp_state_authorities"
                      label="ENTIDAD FEDERATIVA"
                      variant="outlined"
                      error={!!errors.authorities?.mp_state}
                      helperText={errors.authorities?.mp_state || ""}
                      value={formularioState.authorities.mp_state}
                      onChange={(e) =>
                        handleChange("authorities", "mp_state", uppercaseText(e.target.value))
                      }
                    />
                  </Grid>
                  <Grid item xs={12} sm={6}>
                    <Autocomplete
                      fullWidth
                      size="small"
                      id="mp_crime_id_authorities"
                      multiple
                      sx={{
                        borderRadius: "30px",
                      }}
                      options={opcionesDelitos}
                      getOptionLabel={(option) => option.crime || ""}
                      isOptionEqualToValue={(option, value) =>
                        String(option.id) === String(value.id)
                      }
                      value={
                        normalizeCrimeIds(formularioState.authorities.mp_crime_id)
                          .map((crimeId) =>
                              opcionesDelitos.find(
                              (option) => String(option.id) === String(crimeId),
                            ),
                          )
                          .filter(Boolean)
                      }
                      onChange={(e, newValue) =>
                        handleChange(
                          "authorities",
                          "mp_crime_id",
                          newValue.map((crime) => crime.id),
                        )
                      }
                      renderInput={(params) => (
                        <TextField
                          required
                          error={!!errors.authorities?.mp_crime_id}
                          helperText={errors.authorities?.mp_crime_id || ""}
                          {...params}
                          label="DELITOS"
                        />
                      )}
                    />
                  </Grid>
                  <Grid item xs={12} sm={6}>
                    <TextField
                      required
                      sx={{ borderRadius: "30px" }}
                      fullWidth
                      size="small"
                      id="mp_agency_authorities"
                      label="AGENCIA MP"
                      variant="outlined"
                      error={!!errors.authorities?.mp_agency}
                      helperText={errors.authorities?.mp_agency || ""}
                      value={formularioState.authorities.mp_agency}
                      onChange={(e) =>
                        handleChange("authorities", "mp_agency", uppercaseText(e.target.value))
                      }
                    />
                  </Grid>
                  <Grid item xs={12} sm={6}>
                    <TextField
                      sx={{ borderRadius: "30px" }}
                      fullWidth
                      size="small"
                      id="mp_file_type_authorities"
                      label="A.P./ C.I."
                      variant="outlined"
                      value={formularioState.authorities.mp_file_type}
                      onChange={(e) =>
                        handleChange("authorities", "mp_file_type", uppercaseText(e.target.value))
                      }
                      inputProps={{ maxLength: 28 }}
                    />
                  </Grid>
                  <Grid item xs={12} sm={6}>
                    <TextField
                      sx={{ borderRadius: "30px" }}
                      fullWidth
                      size="small"
                      id="mp_nuc_authorities"
                      label="NUC"
                      variant="outlined"
                      error={!!errors.authorities?.mp_nuc}
                      helperText={errors.authorities?.mp_nuc || ""}
                      value={formularioState.authorities.mp_nuc}
                      onChange={(e) =>
                        handleChange("authorities", "mp_nuc", uppercaseText(e.target.value))
                      }
                      onKeyPress={onlyNumber}
                      inputProps={{ maxLength: 13 }}
                    />
                  </Grid>
                  <Grid item xs={12} sm={6}>
                    <TextField
                      sx={{ borderRadius: "30px" }}
                      fullWidth
                      size="small"
                      id="mp_exp_authorities"
                      label="NO. EXPEDIENTE"
                      variant="outlined"
                      error={!!errors.authorities?.mp_exp}
                      helperText={errors.authorities?.mp_exp || ""}
                      value={formularioState.authorities.mp_exp}
                      onChange={(e) =>
                        handleChange("authorities", "mp_exp", uppercaseText(e.target.value))
                      }
                      inputProps={{ maxLength: 19 }}

                    />
                  </Grid>
                  <Grid item xs={12} sm={6}>
                    <TextField
                      required
                      sx={{ borderRadius: "30px" }}
                      fullWidth
                      size="small"
                      id="mp_status_authorities"
                      label="ESTADO DE LA INVESTIGACIÓN"
                      variant="outlined"
                      error={!!errors.authorities?.mp_status}
                      helperText={errors.authorities?.mp_status || ""}
                      value={formularioState.authorities.mp_status}
                      onChange={(e) =>
                        handleChange("authorities", "mp_status", uppercaseText(e.target.value))
                      }
                    />
                  </Grid>
                </>
              )}

              {/* proceso judicial */}
              <Grid item xs={12}>
                <Typography
                  className="my-3"
                  fontWeight="bold"
                >
                  PROCESO JUDICIAL
                </Typography>
              </Grid>              
              <Grid item xs={12} sm={6}>
                <LocalizationProvider dateAdapter={AdapterDayjs}>
                  <DatePicker
                    label="FECHA DE INICIO DEL PROCESO JUDICIAL"
                    id="judicial_start_date_authorities"
                    style={{ width: "40%", marginLeft: "10px" }}
                    value={
                      formularioState.authorities.judicial_start_date
                        ? dayjs(formularioState.authorities.judicial_start_date)
                        : null
                    }
                    onChange={(newValue) =>
                      handleChange(
                        "authorities",
                        "judicial_start_date",
                        newValue ? newValue.format("YYYY-MM-DD") : ""
                      )
                    }
                    format="DD/MM/YYYY"
                    maxDate={dayjs()}
                    slotProps={{
                      textField: {
                        fullWidth: true,
                        size: "small",
                      },
                    }}
                  />
                </LocalizationProvider>
              </Grid>
              <Grid item xs={12} sm={6}>
                <Box sx={{ position: "relative" }}>
                  <TextField
                    sx={{
                      "& .MuiSelect-select": {
                        paddingRight: formularioState.authorities.judicial_jurisdiction
                          ? "64px !important"
                          : undefined,
                      },
                    }}
                    fullWidth
                    size="small"
                    label="COMPETENCIA"
                    variant="outlined"
                    select
                    value={formularioState.authorities.judicial_jurisdiction}
                    onChange={(e) =>
                      handleChange("authorities", "judicial_jurisdiction", uppercaseText(e.target.value))
                    }
                  >
                    <MenuItem value="FEDERAL">FEDERAL</MenuItem>
                    <MenuItem value="LOCAL">LOCAL</MenuItem>
                  </TextField>
                  {clearSelectButton(
                    formularioState.authorities.judicial_jurisdiction,
                    "competencia",
                    () => handleChange("authorities", "judicial_jurisdiction", ""),
                  )}
                </Box>
              </Grid>
              <Grid item xs={12} sm={6}>
                <TextField
                  sx={{ borderRadius: "30px" }}
                  fullWidth
                  size="small"
                  id="judicial_state_authorities"
                  label="ENTIDAD FEDERATIVA"
                  variant="outlined"
                  value={formularioState.authorities.judicial_state}
                  onChange={(e) =>
                    handleChange("authorities", "judicial_state", uppercaseText(e.target.value))
                  }
                />
              </Grid>
              <Grid item xs={12} sm={6}>
                <Box sx={{ position: "relative" }}>
                  <Autocomplete
                    fullWidth
                    size="small"
                    id="judicial_crime_id_authorities"
                    multiple
                    disableClearable
                    sx={{
                      borderRadius: "30px",
                      "& .MuiAutocomplete-inputRoot": {
                        paddingRight: "64px !important",
                      },
                    }}
                    options={opcionesDelitos}
                    getOptionLabel={(option) => option.crime || ""}
                    isOptionEqualToValue={(option, value) =>
                      String(option.id) === String(value.id)
                    }
                    value={
                      normalizeCrimeIds(formularioState.authorities.judicial_crime_id)
                        .map((crimeId) =>
                          opcionesDelitos.find(
                            (option) => String(option.id) === String(crimeId),
                          ),
                        )
                        .filter(Boolean)
                    }
                    onChange={(e, newValue) =>
                      handleChange(
                        "authorities",
                        "judicial_crime_id",
                        newValue.map((crime) => crime.id),
                      )
                    }
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        label="DELITOS"
                      />
                    )}
                  />
                  {clearSelectButton(
                    normalizeCrimeIds(formularioState.authorities.judicial_crime_id).length,
                    "delitos",
                    () => handleChange("authorities", "judicial_crime_id", []),
                  )}
                </Box>
              </Grid>
              <Grid item xs={12} sm={6}>
                <TextField
                  sx={{ borderRadius: "30px" }}
                  fullWidth
                  size="small"
                  id="mp_agency_authorities"
                  label="NÚMERO DE JUZGADO"
                  variant="outlined"
                  error={!!errors.authorities?.court_number}
                  helperText={errors.authorities?.court_number || ""}
                  value={formularioState.authorities.court_number}
                  onChange={(e) =>
                    handleChange("authorities", "court_number", uppercaseText(e.target.value))
                  }
                  inputProps={{ maxLength: 50 }}
                />
              </Grid>
              <Grid item xs={12} sm={6}>
                <TextField
                  sx={{ borderRadius: "30px" }}
                  fullWidth
                  size="small"
                  id="process_number_authorities"
                  label="NÚMERO DE PROCESO"
                  variant="outlined"
                  error={!!errors.authorities?.process_number}
                  helperText={errors.authorities?.process_number || ""}
                  value={formularioState.authorities.process_number}
                  onChange={(e) =>
                    handleChange("authorities", "process_number", uppercaseText(e.target.value))
                  }
                  inputProps={{ maxLength: 9 }}
                />
              </Grid>
              <Grid item xs={12} sm={6}>
                <TextField
                  sx={{ borderRadius: "30px" }}
                  fullWidth
                  size="small"
                  id="judicial_status_authorities"
                  label="ESTADO DEL PROCESO JUDICIAL"
                  variant="outlined"
                  value={formularioState.authorities.judicial_status}
                  onChange={(e) =>
                    handleChange("authorities", "judicial_status", uppercaseText(e.target.value))
                  }
                />
              </Grid>

               {/* derechos humanos */}
              <Grid item xs={12}>
                <Typography
                  className="my-3"
                  fontWeight="bold"
                >
                  PROCEDIMIENTOS ANTE ORGANISMOS NACIONALES E INTERNACIONALES DE DERECHOS HUMANOS
                </Typography>
              </Grid>
              <Grid item xs={12} sm={6}>
                <TextField 
                  required
                  fullWidth 
                  size="small" 
                  label="¿PRESENTÓ QUEJA, PETICIÓN U OTRO TIPO DE SOLICITUD ANTE ALGÚN ORGANISMO DE DD. HH.?" 
                  variant="outlined" 
                  select 
                  error={!!errors.authorities?.complaint_ddhh} 
                  helperText={errors.authorities?.complaint_ddhh || ""}  
                  value={formularioState.authorities.complaint_ddhh}
                  onChange={(e) =>
                  handleChange("authorities", "complaint_ddhh", stringToBoolean(e.target.value))
                  } 
                >
                  <MenuItem value={true}>SI</MenuItem>
                  <MenuItem value={false}>NO</MenuItem>
                </TextField>
              </Grid>          

              {formularioState.authorities?.complaint_ddhh && (
              <>    
                <Grid item xs={12} sm={6}>
                  <LocalizationProvider dateAdapter={AdapterDayjs}>
                    <DatePicker
                      label="FECHA"
                      id="ddhh_date_authorities"
                      style={{ width: "40%", marginLeft: "10px" }}
                      value={
                        formularioState.authorities.ddhh_date
                          ? dayjs(formularioState.authorities.ddhh_date)
                          : null
                      }
                      onChange={(newValue) =>
                        handleChange(
                          "authorities",
                          "ddhh_date",
                          newValue ? newValue.format("YYYY-MM-DD") : ""
                        )
                      }
                      format="DD/MM/YYYY"
                      maxDate={dayjs()}
                      slotProps={{
                        textField: {
                          fullWidth: true,
                          size: "small",
                        },
                      }}
                    />
                  </LocalizationProvider>
                </Grid>
                <Grid item xs={12} sm={6}>
                  <Box sx={{ position: "relative" }}>
                    <TextField
                      sx={{
                        "& .MuiSelect-select": {
                          paddingRight: formularioState.authorities.ddhh_competence
                            ? "64px !important"
                            : undefined,
                        },
                      }}
                      fullWidth
                      size="small"
                      label="COMPETENCIA"
                      variant="outlined"
                      select
                      error={!!errors.authorities?.ddhh_competence}
                      helperText={errors.authorities?.ddhh_competence || ""}
                      value={formularioState.authorities.ddhh_competence}
                      onChange={(e) =>
                        handleChange("authorities", "ddhh_competence", uppercaseText(e.target.value))
                      }
                    >
                      <MenuItem value="FEDERAL">FEDERAL</MenuItem>
                      <MenuItem value="LOCAL">LOCAL</MenuItem>
                      <MenuItem value="INTERNACIONAL">INTERNACIONAL</MenuItem>
                    </TextField>
                    {clearSelectButton(
                      formularioState.authorities.ddhh_competence,
                      "competencia",
                      () => handleChange("authorities", "ddhh_competence", ""),
                    )}
                  </Box>
                </Grid>
                <Grid item xs={12} sm={6}>
                  <TextField
                    sx={{ borderRadius: "30px" }}
                    fullWidth
                    size="small"
                    id="organism_authorities"
                    label="ORGANISMO"
                    variant="outlined"
                    error={!!errors.authorities?.organism}
                    helperText={errors.authorities?.organism || ""}
                    value={formularioState.authorities.organism}
                    onChange={(e) =>
                      handleChange("authorities", "organism", uppercaseText(e.target.value))
                    }
                  />
                </Grid>
                <Grid item xs={12} sm={6}>
                  <TextField
                    sx={{ borderRadius: "30px" }}
                    fullWidth
                    size="small"
                    id="violation_authorities"
                    label="VIOLACIÓN A DD. HH."
                    variant="outlined"
                    error ={!!errors.authorities?.violation}
                    helperText={errors.authorities?.violation || ""}
                    value={formularioState.authorities.violation}
                    onChange={(e) =>
                      handleChange("authorities", "violation", uppercaseText(e.target.value))
                    }
                  />
                </Grid>
                <Grid item xs={12} sm={6}>
                  <TextField
                    sx={{ borderRadius: "30px" }}
                    fullWidth
                    size="small"
                    id="responsible_authority_authorities"
                    label="AUTORIDAD RESPONSABLE"
                    variant="outlined"
                    error={!!errors.authorities?.responsible_authority}
                    helperText={errors.authorities?.responsible_authority || ""}
                    value={formularioState.authorities.responsible_authority}
                    onChange={(e) =>
                      handleChange("authorities", "responsible_authority", uppercaseText(e.target.value))
                    }
                  />
                </Grid>
                <Grid item xs={12} sm={6}>
                  <TextField
                    sx={{ borderRadius: "30px" }}
                    fullWidth
                    size="small"
                    id="folio_authorities"
                    label="FOLIO"
                    variant="outlined"
                    error={!!errors.authorities?.folio}
                    helperText={errors.authorities?.folio || ""}
                    value={formularioState.authorities.folio}
                    onChange={(e) =>
                      handleChange("authorities", "folio", uppercaseText(e.target.value))
                    }
                    inputProps={{ maxLength: 20 }}
                  />
                </Grid> 
                <Grid item xs={12} sm={6}>
                  <TextField
                    sx={{ borderRadius: "30px" }}
                    fullWidth
                    size="small"
                    id="current_status_authorities"
                    label="ESTADO ACTUAL"
                    variant="outlined"
                    value={formularioState.authorities.current_status}
                    onChange={(e) =>
                      handleChange("authorities", "current_status", uppercaseText(e.target.value))
                    }
                  />
                </Grid>
                <Grid item xs={12} sm={6}>
                  <TextField
                    sx={{ borderRadius: "30px" }}
                    fullWidth
                    size="small"
                    id="other_authority_authorities"
                    label="OTRA AUTORIDAD"
                    variant="outlined"
                    value={formularioState.authorities.other_authority}
                    onChange={(e) =>
                      handleChange("authorities", "other_authority", uppercaseText(e.target.value))
                    }
                  />
                </Grid>
              </>
              )}
            </>
          )}

          {state.step === 3 && (
            <>
               <Grid item xs={12}>
                <Typography
                  className="my-3"
                  align="center"
                  fontWeight="bold"
                >
                  VIII HOJA COMPLEMENTARIA
                </Typography>
              </Grid>

              <Grid item xs={12} sm={6}>
                <TextField
                  sx={{ borderRadius: "30px" }}
                  fullWidth
                  size="small"
                  id="ceeav_code_complementary_form"
                  label="COD-CEEAV"
                  variant="outlined"
                  value={formularioState.complementary_form.ceeav_code}
                  onChange={(e) =>
                    handleChange("complementary_form", "ceeav_code", uppercaseText(e.target.value))
                  }
                />
              </Grid>
              <Grid item xs={12} sm={6}>
                <TextField
                  sx={{ borderRadius: "30px" }}
                  fullWidth
                  size="small"
                  id="case_file_complementary_form"
                  label="FOLIO:CEEAV/SOPC"
                  variant="outlined"
                  value={formularioState.complementary_form.case_file}
                  onChange={(e) =>
                    handleChange("complementary_form", "case_file", uppercaseText(e.target.value))
                  }
                />
              </Grid>
              <Grid item xs={12} sm={6}>
                <Box sx={{ position: "relative" }}>
                  <TextField
                    sx={{
                      "& .MuiSelect-select": {
                        paddingRight: formularioState.complementary_form.referring_institution
                          ? "64px !important"
                          : undefined,
                      },
                    }}
                    fullWidth
                    size="small"
                    label="INSTITUCIÓN QUE LO REFIERE"
                    variant="outlined"
                    select
                    value={formularioState.complementary_form.referring_institution}
                    onChange={(e) =>
                      handleChange("complementary_form", "referring_institution", uppercaseText(e.target.value))
                    }
                  >
                    <MenuItem value="FISCALÍA GENERAL DEL ESTADO">FISCALÍA GENERAL DEL ESTADO</MenuItem>
                    <MenuItem value="PODER JUDICIAL">PODER JUDICIAL</MenuItem>
                    <MenuItem value="CEDH MICHOACÁN">CEDH MICHOACÁN</MenuItem>
                    <MenuItem value="DEPENDENCIAS ESTATALES">DEPENDENCIAS ESTATALES</MenuItem>
                    <MenuItem value="AYUNTAMIENTOS">AYUNTAMIENTOS</MenuItem>
                    <MenuItem value="SEIMUJER">SEIMUJER</MenuItem>
                    <MenuItem value="CEAV FEDERAL">CEAV FEDERAL</MenuItem>
                    <MenuItem value="PERSONAL">PERSONAL</MenuItem>
                  </TextField>
                  {clearSelectButton(
                    formularioState.complementary_form.referring_institution,
                    "institución que lo refiere",
                    () => handleChange("complementary_form", "referring_institution", ""),
                  )}
                </Box>
              </Grid>
              <Grid item xs={12} sm={6}>
                <TextField 
                  required
                  fullWidth 
                  size="small" 
                  label="SERVICIO SOLICITADO" 
                  variant="outlined" 
                  select 
                  SelectProps={{
                    multiple: true,
                    renderValue: (selected) => selected.join(', ')
                  }}
                  error={!!errors.complementary_form?.requested_services} 
                  helperText={errors.complementary_form?.requested_services || ""}  
                  value={formularioState.complementary_form.requested_services}
                  onChange={(e) =>
                    handleChange("complementary_form", "requested_services", e.target.value)
                  } 
                >
                  <MenuItem value="ASESORÍA JURÍDICA DE MATERIA PENAL">ASESORÍA JURÍDICA DE MATERIA PENAL</MenuItem>
                  <MenuItem value="ASESORÍA JURÍDICA DDHH U OTRAS MATERIAS">ASESORÍA JURÍDICA DDHH U OTRAS MATERIAS</MenuItem>
                  <MenuItem value="ATENCIÓN MÉDICA Y PSICOLÓGICA">ATENCIÓN MÉDICA Y PSICOLÓGICA</MenuItem>
                  <MenuItem value="AYUDA INMEDIATA O DE PROTECCIÓN">AYUDA INMEDIATA O DE PROTECCIÓN</MenuItem>
                  <MenuItem value="VINCULACIÓN CON OTRAS INSTITUCIONES">VINCULACIÓN CON OTRAS INSTITUCIONES</MenuItem>
                  <MenuItem value="OTROS SERVICIOS">OTROS SERVICIOS</MenuItem>
                </TextField>
              </Grid>
              <Grid item xs={12} sm={6}>
                <Box sx={{ position: "relative" }}>
                  <TextField
                    sx={{
                      "& .MuiSelect-select": {
                        paddingRight: formularioState.complementary_form.registry_status
                          ? "64px !important"
                          : undefined,
                      },
                    }}
                    fullWidth
                    size="small"
                    label="INSCRIPCIÓN EN EL REGISTRO ESTATAL DE VÍCTIMAS"
                    variant="outlined"
                    select
                    value={formularioState.complementary_form.registry_status}
                    onChange={(e) =>
                      handleChange("complementary_form", "registry_status", uppercaseText(e.target.value))
                    }
                  >
                    <MenuItem value="COMPLETO">COMPLETO</MenuItem>
                    <MenuItem value="PENDIENTE">PENDIENTE</MenuItem>
                  </TextField>
                  {clearSelectButton(
                    formularioState.complementary_form.registry_status,
                    "inscripción en el registro estatal de víctimas",
                    () => handleChange("complementary_form", "registry_status", ""),
                  )}
                </Box>
              </Grid>
              
              <Grid item xs={12}>
                <Typography
                  className="my-3"
                  align="center"
                  fontWeight="bold"
                >
                  IX GRUPOS VULNERABLES
                </Typography>
              </Grid>
              <Grid item xs={12} sm={6}>
                <TextField 
                  required
                  fullWidth 
                  size="small" 
                  label="PERTENECE A ALGÚN GRUPO VULNERABLE" 
                  variant="outlined" 
                  select 
                  error={!!errors.complementary_form?.is_vulnerable_group} 
                  helperText={errors.complementary_form?.is_vulnerable_group || ""}  
                  value={formularioState.complementary_form.is_vulnerable_group}
                  onChange={(e) =>
                  handleChange("complementary_form", "is_vulnerable_group", stringToBoolean(e.target.value))
                  } 
                >
                  <MenuItem value={true}>SI</MenuItem>
                  <MenuItem value={false}>NO</MenuItem>             
                </TextField>
              </Grid>
              {formularioState.complementary_form.is_vulnerable_group && (
                <>
                  <Grid item xs={12} sm={6}>
                    <TextField 
                      required
                      fullWidth 
                      size="small" 
                      label="GRUPO VULNERABLE AL QUE PERTENECE" 
                      variant="outlined" 
                      select 
                      SelectProps={{
                        multiple: true,
                        renderValue: (selected) => selected.join(', ')
                      }}
                      error={!!errors.complementary_form?.vulnerable_group}
                      helperText={errors.complementary_form?.vulnerable_group || ""}
                      value={formularioState.complementary_form.vulnerable_group}
                      onChange={(e) =>
                        handleChange("complementary_form", "vulnerable_group", e.target.value)
                      } 
                    >
                      <MenuItem value="NIÑA/O Ó ADOLECENTE">NIÑA/O Ó ADOLECENTE</MenuItem>
                      <MenuItem value="ADULTO MAYOR">ADULTO MAYOR</MenuItem>
                      <MenuItem value="CONDICIÓN DE DISCAPACIDAD">CONDICIÓN DE DISCAPACIDAD</MenuItem>
                      <MenuItem value="MIGRANTE">MIGRANTE</MenuItem>
                      <MenuItem value="GRUPO INDIGENA">GRUPO INDIGENA</MenuItem>
                      <MenuItem value="REFUGIADO">REFUGIADO</MenuItem>
                      <MenuItem value="ASILADO POLÍTICO">ASILADO POLÍTICO</MenuItem>
                      <MenuItem value="DEFENSOR DE DERECHOS HUMANOS">DEFENSOR DE DERECHOS HUMANOS</MenuItem>
                      <MenuItem value="PERIODISTA">PERIODISTA</MenuItem>

                    </TextField>
                  </Grid>
            
                  <Grid item xs={12} sm={6}>
                    <TextField
                      required
                      sx={{ borderRadius: "30px" }}
                      fullWidth
                      size="small"
                      id="notes_complementary_form"
                      label="INFORMACIÓN ADICIONAL"
                      variant="outlined"
                      error={!!errors.complementary_form?.notes}
                      helperText={errors.complementary_form?.notes || ""}
                      value={formularioState.complementary_form.notes}
                      onChange={(e) =>
                        handleChange("complementary_form", "notes", uppercaseText(e.target.value))
                      }
                    />
                  </Grid>
                </>
              )}
              <Grid item xs={12} sm={6}>
                <TextField 
                  required
                  fullWidth 
                  size="small" 
                  label="¿DEJA MENORES DE EDAD EN ESTADO DE ORFANDAD?" 
                  variant="outlined" 
                  select 
                  error={!!errors.complementary_form?.leaves_orphans}
                  helperText={errors.complementary_form?.leaves_orphans || ""}
                  value={formularioState.complementary_form.leaves_orphans}
                  onChange={(e) =>
                  handleChange("complementary_form", "leaves_orphans", stringToBoolean(e.target.value))
                  } 
                >
                  <MenuItem value={true}>SI</MenuItem>
                  <MenuItem value={false}>NO</MenuItem>
                </TextField>
              </Grid>
              {formularioState.complementary_form.leaves_orphans && (
                <>
                  <Grid item xs={12} sm={6}>
                    <TextField
                      sx={{ borderRadius: "30px" }}
                      required
                      fullWidth
                      size="small"
                      id="orphans_count_complementary_form"
                      label="¿CUÁNTOS?"
                      variant="outlined"
                      error={!!errors.complementary_form?.orphans_count}
                      helperText={errors.complementary_form?.orphans_count || ""}
                      value={formularioState.complementary_form.orphans_count}
                      onChange={(e) =>
                        handleChange("complementary_form", "orphans_count", uppercaseText(e.target.value))
                      }
                      onKeyPress={onlyNumber}
                      inputProps={{ maxLength: 3 }}

                    />
                  </Grid>
                </>
              )}
              <Grid item xs={12} sm={6}>
                <Box sx={{ position: "relative" }}>
                  <TextField
                    sx={{
                      "& .MuiSelect-select": {
                        paddingRight: formularioState.complementary_form.violence_types
                          ? "64px !important"
                          : undefined,
                      },
                    }}
                    fullWidth
                    size="small"
                    label="EL HECHO VICTIMIZANTE SE DEBIÓ A:"
                    variant="outlined"
                    select
                    value={formularioState.complementary_form.violence_types}
                    onChange={(e) =>
                      handleChange("complementary_form", "violence_types", uppercaseText(e.target.value))
                    }
                  >
                    <MenuItem value="RELIGIÓN O CREENCIAS">RELIGIÓN O CREENCIAS</MenuItem>
                    <MenuItem value="PREFERENCIA U ORIENTACIÓN SEXUAL">PREFERENCIA U ORIENTACIÓN SEXUAL</MenuItem>
                    <MenuItem value="IDENTIDAD O EXPRESIÓN DE GÉNERO">IDENTIDAD O EXPRESIÓN DE GÉNERO</MenuItem>
                    <MenuItem value="SEXO">SEXO</MenuItem>
                    <MenuItem value="RAZA">RAZA</MenuItem>
                    <MenuItem value="OTRO">OTRO</MenuItem>
                  </TextField>
                  {clearSelectButton(
                    formularioState.complementary_form.violence_types,
                    "hecho victimizante",
                    () => handleChange("complementary_form", "violence_types", ""),
                  )}
                </Box>
              </Grid>
              {formularioState.complementary_form.violence_types === "OTRO" && (
                <>
                  <Grid item xs={12} sm={6}>
                    <TextField
                      required
                      sx={{ borderRadius: "30px" }}
                      fullWidth
                      size="small"
                      id="other_violence_complementary_form"
                      label="OTRO"
                      variant="outlined"
                      error={!!errors.complementary_form?.other_violence}
                      helperText={errors.complementary_form?.other_violence || ""}
                      value={formularioState.complementary_form.other_violence}
                      onChange={(e) =>
                        handleChange("complementary_form", "other_violence", uppercaseText(e.target.value))
                      }
                    />
                  </Grid>
                </>
              )}
              <Grid item xs={12} sm={6}>
                <Box sx={{ position: "relative" }}>
                  <TextField
                    sx={{
                      "& .MuiSelect-select": {
                        paddingRight: normalizeMultiSelect(
                          formularioState.complementary_form.violence_feminist,
                        ).length
                          ? "64px !important"
                          : undefined,
                      },
                    }}
                    fullWidth
                    size="small"
                    label="INFORMACIÓN DE VIOLENCIA CONTRA LAS MUJERES"
                    variant="outlined"
                    select
                    SelectProps={{
                      multiple: true,
                      renderValue: (selected) => selected.join(", "),
                    }}
                    error={!!errors.complementary_form?.violence_feminist}
                    helperText={errors.complementary_form?.violence_feminist || ""}
                    value={normalizeMultiSelect(
                      formularioState.complementary_form.violence_feminist,
                    )}
                    onChange={(e) =>
                      handleChange(
                        "complementary_form",
                        "violence_feminist",
                        normalizeMultiSelect(e.target.value).map(uppercaseText),
                      )
                    }
                  >
                    <MenuItem value="PSICOLÓGICA">PSICOLÓGICA</MenuItem>
                    <MenuItem value="FÍSICA">FÍSICA</MenuItem>
                    <MenuItem value="ECONÓMICA">ECONÓMICA</MenuItem>
                    <MenuItem value="PATRIMONIAL">PATRIMONIAL</MenuItem>
                    <MenuItem value="SEXUAL">SEXUAL</MenuItem>
                    <MenuItem value="OBSTÉTRICA">OBSTÉTRICA</MenuItem>
                    <MenuItem value="FEMINICIDA">FEMINICIDA</MenuItem>
                    <MenuItem value="OTRA">OTRA</MenuItem>
                  </TextField>
                  {clearSelectButton(
                    normalizeMultiSelect(
                      formularioState.complementary_form.violence_feminist,
                    ).length,
                    "información de violencia contra las mujeres",
                    () => handleChange("complementary_form", "violence_feminist", []),
                  )}
                </Box>
              </Grid>
              {normalizeMultiSelect(
                formularioState.complementary_form.violence_feminist,
              ).includes("OTRA") && (
                <>  
                  <Grid item xs={12} sm={6}>
                    <TextField
                      required
                      sx={{ borderRadius: "30px" }}
                      fullWidth
                      size="small"
                      id="other_violence_feminist_complementary_form"
                      label="OTRA"
                      variant="outlined"
                      error={!!errors.complementary_form?.other_violence_feminist}
                      helperText={errors.complementary_form?.other_violence_feminist || ""} 
                      value={formularioState.complementary_form.other_violence_feminist}
                      onChange={(e) =>
                        handleChange("complementary_form", "other_violence_feminist", uppercaseText(e.target.value))
                      }
                    />
                  </Grid>
                </>
              )}
              <Grid item xs={12} sm={6}>
                <TextField
                  sx={{ borderRadius: "30px" }}
                  fullWidth
                  size="small"
                  id="offender_name_complementary_form"
                  label="NOMBRE DEL IMPUTADO"
                  variant="outlined"
                  value={formularioState.complementary_form.offender_name}
                  onChange={(e) =>
                    handleChange("complementary_form", "offender_name", uppercaseText(e.target.value))
                  }
                />
              </Grid>  
              <Grid item xs={12} sm={6}>
                <TextField
                  sx={{ borderRadius: "30px" }}
                  fullWidth
                  size="small"
                  id="relationship_complementary_form"
                  label="RELACIÓN O PARENTESCO"
                  variant="outlined"
                  value={formularioState.complementary_form.relationship}
                  onChange={(e) =>
                    handleChange("complementary_form", "relationship", uppercaseText(e.target.value))
                  }
                />
              </Grid>
            </>
          )}
        </Grid>

        {/* <div className="my-3">
          {errors.nombre && (
            <div style={{ color: "red", fontSize: "12px" }}>
              Nombre: {errors.nombre}
            </div>
          )}
          {errors.apellidoPaterno && (
            <div style={{ color: "red", fontSize: "12px" }}>
              Apellido Paterno: {errors.apellidoPaterno}
            </div>
          )}
          {errors.curp && (
            <div style={{ color: "red", fontSize: "12px" }}>
              Curp: {errors.curp}
            </div>
          )}
          {errors.email && (
            <div style={{ color: "red", fontSize: "12px" }}>
              Email: {errors.email}
            </div>
          )}
          {errors.calle && (
            <div style={{ color: "red", fontSize: "12px" }}>
              Calle: {errors.calle}
            </div>
          )}
          {errors.municipio && (
            <div style={{ color: "red", fontSize: "12px" }}>
              Municipio: {errors.municipio}
            </div>
          )}
          {errors.estado && (
            <div style={{ color: "red", fontSize: "12px" }}>
              Estado: {errors.estado}
            </div>
          )}
          {errors.peticion && (
            <div style={{ color: "red", fontSize: "12px" }}>
              Peticion: {errors.peticion}
            </div>
          )}
        </div> */}

        <div>
          {state.step === 0 ? (
            <div className="d-flex justify-content-end my-3">
              <div
                style={{ width: "100px" }}
                className="cta cta--guinda"
                onClick={handleAddStep}
              >
                Siguiente
              </div>
            </div>
          ) : (
            <div className="d-flex justify-content-end my-3">
              <div
                style={{ width: "100px" }}
                className="cta cta--white"
                onClick={handleRemoveStep}
              >
                Atras
              </div>
              {state.step !== 3 && (
                <div
                  style={{ width: "100px" }}
                  className="cta cta--guinda ms-3"
                  onClick={handleAddStep}
                >
                  Siguiente
                </div>
              )}
              {state.step > 2 && (
                <div
                  className="cta cta--guinda ms-2"
                  onClick={handleSubmitFud}
                >
                  {isEditing ? "Actualizar FUD" : "Crear FUD"}
                </div>
              )}
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default CrearFudView;
